import React from 'react';
import { connect } from 'dva';
import { routerRedux } from 'dva/router';
import {
  Input,
  Button,
  Select,
  DatePicker,
  Icon,
  message,
  Tabs,
  Tooltip,
  Menu,
  Dropdown,
  Modal,
  Checkbox,
  Alert,
  Radio
} from 'antd';
import qs from 'qs';

import { captureException } from '@sentry/react';
import cloneDeep from 'lodash/cloneDeep';
import intl from 'react-intl-universal';
import StandardTable from 'components/StandardTable';
import Mapping from 'components/Mapping';
import OnlyPagination from 'components/OnlyPagination';
import ProductPoolBanner from 'components/ProductPoolBanner';
import moment from 'moment-timezone';
import GuideModal from './GuideModal';
import className from 'classnames';
import getAdminRole from 'utils/getAdminRole';
import { getVersion } from 'utils/bannerWhiteList';
import OldUiOutBanner from 'components/OldUiOut/OldUiOutBanner';
import RutBanner from './RutBanner';
import OberloErrorStatus from 'components/OldUiOut/OrderAeError';

import FilterSearch from './FilterSearch';
import FilterDrawer from 'components/FilterDrawer/FilterDrawer';
import FilterHeader from 'components/FilterHeader';
import InputGuide from 'components/FilterDrawer/InputGuide'

import { Post, Get, Put } from 'utils/request';
import withTracker from '../../common/tracker.js';
import reactGaEvent from '../../utils/GAEvent';
import { handleErrorTips } from './extendUtils'
import { getQueryUrlParams } from 'utils/global'
import {
  createCashBackTask,
  fixedZero,
  getLanguage,
  getChromeExtUrl
} from '../../utils/utils';
import {
  sendRequestToExtension,
  fetchProductInfo
} from '../../utils/fetchFromExtension';

import OrderOne from './OrderOne';
import {OrderConfirm} from '../../features/index';
import OrderFulfilled from './OrderFulfilled.js';
import OrderRollBack from './OrderRollBack.js';
import OrderArchive from './OrderArchive.js';
import SyncAliProcess from './component/SyncAliProcess';
import SyncAliTimeRangeSelect from './component/SyncAliTimeRangeSelect';

import orderStyles from './Order.less';
import styles from './Index.less';
import './Order.css';
import radioStyles from '../Order/FilterSearch/FilterSearch.less'

import tipToAliPay from '../../assets/order/tipToAliPay.png';
import succ from 'assets/alert/pushsucc.png';
import error from 'assets/alert/pusherr.png';
import closesucc from 'assets/alert/closesucc.png';
import closeerr from 'assets/alert/closeerr.png';

import { dispatchEventForGuide } from '../BeginnerGuide/util';
import timezone from '../../common/timezone';
import { BASE_URL } from '../../common/sysconfig';
import { getAuthorityHeader } from '../../utils/authority';

import { ChromeAction, OrderAction, GuildeAction } from 'actions';
import classnames from 'classnames'

import {
  getOrderShowData,
  orderStatusMapArr,
  checkBannerVisibleByCode,
  checkLineItemBannerVisible,
  checkChileTaxNumberValid,
  filterUpdateExtLineItems
} from './util';
import RefreshMask from '../../components/RefreshMask/index.js';
import AdBanner from 'components/AdBanner';
import checkAeAccount from './checkAeAccount';
import NewUserWithoutAeModal from '../../components/NewUserModal/NewUserWithoutAeModal';

import { webCustomCollect, sendNoviceGuidanceInfo } from 'utils/utils';

import ExtensionPlaceOrderProcess from './component/ExtensionPlaceOrderProcess';
// import CheckInterreptedExtTask from './component/CheckInterreptedExtTask';
import {mock} from './mock'
import { checkExtVersion, EXT_VERSION } from 'utils/placeOrderViaExt';

import { CommonDataCollect } from '../../utils/utils';
import SyncAEPriceInfoToShopify from 'components/SyncAEPriceInfoToShopify';
import { getAELoginStatus } from 'utils/localAEUtils';
import { PaymentOrder } from '../../features/index';
import { ThemeProvider } from '@material-ui/core';
import SyncTmallPayment from './component/TmallPayment/SyncTmallPayment';

const { Option } = Select;
const { RangePicker } = DatePicker;
const { TabPane } = Tabs;


let userId = ['bqa49860e4rllmptor3g','c7l6qkq2qhp000e5dg5g','c8svftaimtqg00f4pqv0', 'c6frfk046ft000ccnl6g', 'c3filti8i06000epj0i0', 'c9lhfge67o9g008utq70', 'bum87g4pahj000btual0', 'c39m6dggcg1g00deppig', 'c88ihaucaqgg00d10lng', 'c8j4s3csn4l000bgpmog', 'c76207pgicog009urfeg', 'c98sk5i4q7a000ah6mdg', 'c89rkfgm759g00fnm13g', 'c98ab8bbjvhg00f5rnvg', 'c71a14u2knlg00eqp3r0', 'c7gmv6665bmg00aaf2ng', 'c6qf64fobeqg009p15jg', 'c3ip2355npbg00cckpp0', 'c7mar9a2qhp000e6sda0', 'c9lclufehec000bngnhg', 'bs9gm75l1h2000erkve0', 'beanvlbcu2umhegpatj0', 'c61ktuav51s0009otjs0', 'c2u6kqjpu0ng00b5fq60', 'c8ee4v8au14000at4c10', 'bof48adqp3n51c905pkg', 'bkj08hld0c8mrs27a6ug', 'bst45lsfua3000dus8v0', 'c5cda0jln4og00dpasm0', 'c7ngqr8f1ec000cuoie0', 'boab3dtqp3n76fig7t70', 'bqn8fklqp3n79humv70g', 'c7p7r08uhi3g00b1dhr0', 'c8lddakh7eng009r2i5g', 'bub8oo9fvl5g009go3cg', 'c9299na2hq0000bqmnb0', 'bok4rqdqp3n3abrvperg', 'bvhu4a3q1dsg0081nekg', 'c4ns43jaf7ig00dqhmt0', 'c244p7e595v000d5meig', 'c7f6jvdpil0000dbrvhg', 'c85hhojabs1000c1ml20', 'c2ej2f6np9kg00dh03rg', 'c79k893avmbg00fh75lg', 'c8dl3j8au14000as3ih0', 'c69a273tk80g00d2234g', 'bv9fdq45v12g00e43alg', 'bng5jjabcd4000bjkki0', 'c97q2l2he7o000bbgtgg', 'c9865da4q7a000afjvkg', 'bupltcml4nng00f611r0', 'c6einrmlvlhg008a8q70', 'c83ahc2j6t7g00fk4mj0', 'bu5v80bodfv000a0ccu0', 'c9dincfqh70g00bge8vg', 'bsti71fr7ui000a8eubg', 'c7fkna8ueva000f1kqi0', 'c77hua9uh2og009o5eog', 'c5p04fremfg000eqs8c0', 'bphtpf5qp3ndqjlhbdmg', 'c530pcpbopq0008qpleg', 'bp279sdqp3n5mj1nhlc0', 'c8bfpuv44cg0008ouorg', 'c823bsfhb5pg009sncvg', 'c036psn2gacg00clf33g', 'c8cerhv7umig00fm5890', 'c5i9ifa5deu000fhg0h0', 'c9fbfo6402a000ebarl0', 'c84qidgnv3bg00fnfh9g', 'bpalaadqp3n5vhmo49u0', 'c9geu2uo90qg00ajtkcg', 'bikcpu5d0c8oegcndpe0', 'c750h6g53s0g00f4qctg', 'c9e960fqh70g00bhcde0', 'bsge6ta5uk4000b9nj1g', 'c8oapumvgm0000cj0apg', 'c886b7gm759g00flmhf0', 'bu1okj5g8qt000cvj6f0', 'c9m3p7667o9g0090ip0g', 'c8vbgl42lq2000bu3dj0', 'c7i0qtu65bmg00ac39eg', 'c9gvsvcca3ng00btqri0', 'c2eon5unp9kg00dh7d7g', 'c0allh2k1tp000bhtqd0', 'c9gcvcfqci0000dre8fg', 'c1jm389tqfcg0098ddkg', 'c9jkp9s5t5og00dh2kc0', 'c7io5iu65bmg00ad084g', 'c9lpk8m67o9g008vkb4g', 'c9kud13tlbr000evdsag']
let CUSTOMIZATION_USER = ['c8550donmuqg009eqr10','bvkkqb2q82pg0090d3r0','bqa49860e4rllmptor3g'];
let CUSTOMIZATION_USER_FLAG = true;
let DEFAULT_SEARCH_TIME = true;

@connect(
  ({ order, loading, topBtn, login, global, dropshippersetting, user }) => ({
    order,
    global,
    loading: loading.models.order,
    topBtn,
    okLoading: loading.effects['order/bind'],
    purchaseLoading: loading.effects['order/purchase'],
    updateLoading: loading.effects['order/update'],
    syncCanceledOrderLoading: loading.effects['order/syncCanceledOrder'],
    bLoading: loading.effects['order/express'],
    unBindLoading: loading.effects['topBtn/unbind'],
    bindLoading: loading.effects['topBtn/aliauth'],
    userInfo: login.userInfo,
    storeIdWithOrder: global.storeIdWithOrder,
    getOrderAliSumLoading: loading.effects['order/getOrderAliSum'],
    timezoneRegion: global.timezoneRegion,
    admitadCheckCode: dropshippersetting.admitadCheckCode,
    unsupportedShipping: global.unsupportedShipping,
    lang: global.lang,
    tutorialType: login.userInfo?.tutorial_type,
    noviceGuidanceInfo: user?.noviceGuidanceInfo,
    localAEInfo: global.localAEInfo,
    settingTimeZone:global?.settingTimeZone,
    plan: user?.plan
  })
)
@withTracker
export default class OrderComponent extends React.PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      gopay : true, //提示支付橫條
      changetab:2,
      orderList: [],
      selectedRows: [],
      selectedRowsId: [],
      status: 2,
      showGlobalPlaceOrder: false, // 屏幕中间的批量下单按钮
      showPlaceOrder: false, // 是否显示下单弹窗
      showDeleteSearch: false, // 搜索输入框上的删除图标
      searchKey: '', // 搜索内容
      showMapping: false,
      showFulfilledModal: false, // 是否展示把订单设置成fulfilled状态的弹窗
      isSync: false, // 是否正在同步订单
      visibleFulfillOrdersManuallyTip: false, // 批量fulfilled提示
      showRollBack: false, // 是否展示回滚弹窗
      showOrderResult: false, // 手否展示下单状态
      showArchive: false,
      awaitingOrderNumber: 0,
      succeedOrderNumber: 0,
      failedOrderNumber: 0,
      mappingProduct: null, // 要mapping的shopify商品
      showRefreshMask: false,
      sumSync: 0,
      showReviewBanner: false,
      types: '', // 用户付费等级
      // placeOrderType: undefined, // 'single' | 'batch' 下单类型
      bannerData: {},
      checkAeModalType: undefined,
      isNewUserAeModalShow: false,
      showPayPalModal: false,
      aliLoading: false,
      showSyncTimeRange: false,
      isFixed: false,
      guideModal: false,
      tutorial_type: 0,
      settingTimeZone:'',
      orderSplitData: [
        {
          sp_order_id: 'c58nj0anr25000ds68n0',
          status: 1
        },
        {
          sp_order_id: 'c5nudf48kbkg00a4j5d0',
          status: 3
        }
      ],
      flagsList: [
        {
          id: 0,
          img: 'https://img.dsers.com/images/order-flags-icon/11.png',
          name: intl.get('order.flags.None'),
          checked: false
        },
        {
          id: 1,
          img: 'https://img.dsers.com/images/order-flags-icon/22.png',
          name: intl.get('order.flags.Grey'),
          checked: false
        },
        {
          id: 2,
          img: 'https://img.dsers.com/images/order-flags-icon/33.png',
          name: intl.get('order.flags.Blue'),
          checked: false
        },
        {
          id: 3,
          img: 'https://img.dsers.com/images/order-flags-icon/44.png',
          name: intl.get('order.flags.Green'),
          checked: false
        },
        {
          id: 4,
          img: 'https://img.dsers.com/images/order-flags-icon/55.png',
          name: intl.get('order.flags.Yellow'),
          checked: false
        },
        {
          id: 5,
          img: 'https://img.dsers.com/images/order-flags-icon/66.png',
          name: intl.get('order.flags.Red'),
          checked: false
        }
      ],
      cancelFlagsList:[],
      filteringMapp:[
        {
          id:1,
          name:intl.get('order.filter_mapping_default')
        },
        {
          id:2,
          name:intl.get('order.filter_mapped_order')
        },
        {
          id:3,
          name:intl.get('order.filter_no_mapped_order')
        }
      ],
      filteringMappStatus:{},
      attention:false,
      oldOrderList:[],
      drawerVisiable:false,
      searchFlag:false,
      confirmSelect:false,
      tagVisiable:false,
      checkLocalAEAccountLoading: false,
      searchInputType:1,
      dataType:[
        {
          type:1,
          timestamp:0,
          name:'Today'
        },
        {
          type:2,
          timestamp:7,
          name:'Last 7 days'
        },
        {
          type:3,
          timestamp:30,
          name:'Last 30 days'
        },
        {
          type:4,
          timestamp:90,
          name:'Last 90 days'
        },
        {
          type:5,
          timestamp:180,
          name:'Last 180 days'
        }
      ],
      dateRadioDefaultType:3,
      hidden:true,
      searchFlagBtn:false,
      showPaymentOrder:false,
      showPaymentResult:false,
      paymentProcessData:{},

      istimeShow:false//控制30天是否显示
    };

    this.cacheOrdersStoreId =
      localStorage.getItem('currentOrdersStoreId') || 'all';
    this.isNewOrderResultApi = window.DSERS_O_R || getAdminRole();
    this.scrollTimer = null;
  }

  timeGap = -1;

  componentWillMount() {
    // 获取用户付费等级
    this.props.dispatch({
      type: 'order/payment',
      payload: {
        callback: d => {
          if (d.code === 2000) {
            this.setState({
              types: d.data.type
            });
          }
        }
      }
    });
    this.getPayPalState();
  }

  // 调取接口查看是否有order进入

  componentDidMount() {
    console.log('storeId值为 componentDidMount')
    const {
      storeIdWithOrder, // redux中order页店铺id 默认undefined
      userInfo: { stores, has_import, tutorial_type, user_id },
      history:{location:{ search }},
      settingTimeZone
    } = this.props;
    // console.log(has_import, tutorial_type, 'userInfo-=-=-=-=')


    if(window.location.href.includes('orderKey')){

      let orderKey = getQueryUrlParams(window.location.href, 'orderKey');
      let tabKey = getQueryUrlParams(window.location.href, 'tabKey')


      this.status = Number(tabKey)
      this.searchKey = decodeURIComponent(orderKey);
      this.setState({
        searchKey:decodeURIComponent(orderKey),
        status:Number(tabKey),
      })
    }

    //获取缓存的值
    if(CUSTOMIZATION_USER.includes(user_id)){
      this.setState({
        filteringMappStatus:{
          id:2,
          name:intl.get('order.filter_mapped_order'),
        }
      })
      this.cancenData.filteringMappStatus = {
        id:2,
        name:intl.get('order.filter_mapped_order'),
      }
    }

    this.props.dispatch({
      type:'global/timezone',
      payload:{
        callback: d => {
          console.log('d为', d)
          if(d.code == 2000 && d.data == ''){
            this.setState({
              settingTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
            });
            localStorage.setItem('actionStatus_v3',JSON.stringify({
              EDate:this.EDate,
              SDate:this.SDate,
              timeZone:Intl.DateTimeFormat().resolvedOptions().timeZone,
              startDatetime:this.startDatetime,
              endDatetime:this.endDatetime
            }))

            //缓存定制化用户的值
            if(!localStorage.getItem('CUSTOMIZATION_USER_ACTION_V3')){
              localStorage.setItem('CUSTOMIZATION_USER_ACTION_V3',JSON.stringify({
                EDate:this.EDate,
                SDate:this.SDate,
                timeZone:Intl.DateTimeFormat().resolvedOptions().timeZone,
                startDatetime:this.startDatetime,
                endDatetime:this.endDatetime,
                filteringMappStatus:{
                  id:2,
                  name:intl.get('order.filter_mapped_order'),
                },
                country:'',
                flags:this.state.flagsList,
                size:40,
                dateRadioDefaultType:3
              }))
              this.cancenData.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
            }else{             
              if(CUSTOMIZATION_USER.includes(user_id)){
                let canceldata = JSON.parse(localStorage.getItem('CUSTOMIZATION_USER_ACTION_V3'))

                this.cancelFlags = canceldata.flags
                this.cancelIndex = canceldata.flags.filter(item => item.checked).map(item => item.id)
                this.statusCountry = canceldata.country
                this.SDate = canceldata.SDate
                this.EDate = canceldata.EDate
                this.currentTimezone = canceldata.timeZone
                this.pageSize = parseInt(canceldata.size)
                this.cancenData.timeZone = canceldata.timeZone

                this.cancenData = {
                  startTime:{
                    startDatetime:canceldata.startDatetime,
                    SDate:canceldata.SDate
                  },
                  endTime:{
                    endDatetime: canceldata.endDatetime,
                    EDate:canceldata.EDate
                  },
                  timeZone:canceldata.timeZone,
                  country:canceldata.country,
                  filteringMappStatus:canceldata.filteringMappStatus
                }

                this.startDatetime = canceldata.startDatetime
                this.endDatetime = canceldata.endDatetime
                this.setState({
                  settingTimeZone:canceldata.timeZone,
                  filteringMappStatus:canceldata.filteringMappStatus,
                  flagsList:canceldata.flags,
                  dateRadioDefaultType:canceldata.dateRadioDefaultType
                })
                this.dateRadioDefaultType = canceldata.dateRadioDefaultType
              } 
            }
            

          }else{
            let TimeZone = timezone.filter(item => item.label == d.data)[0]
            this.setState({
              settingTimeZone: TimeZone?.value
            });
            localStorage.setItem('actionStatus_v3',JSON.stringify({
              EDate:this.EDate,
              SDate:this.SDate,
              timeZone:TimeZone?.value,
              startDatetime:this.startDatetime,
              endDatetime:this.endDatetime
            }))
            this.cancenData.timeZone = TimeZone?.value
            if(!localStorage.getItem('CUSTOMIZATION_USER_ACTION_V3')){
              localStorage.setItem('CUSTOMIZATION_USER_ACTION_V3',JSON.stringify({
                EDate:this.EDate,
                SDate:this.SDate,
                timeZone:TimeZone?.value,
                startDatetime:this.startDatetime,
                endDatetime:this.endDatetime,
                filteringMappStatus:{
                  id:2,
                  name:intl.get('order.filter_mapped_order'),
                },
                country:'',
                flags:this.state.flagsList,
                size:40,
                dateRadioDefaultType:3
              }))
            }else{
              if(CUSTOMIZATION_USER.includes(user_id)){
                let canceldata = JSON.parse(localStorage.getItem('CUSTOMIZATION_USER_ACTION_V3'))

                this.cancelFlags = canceldata.flags
                this.cancelIndex = canceldata.flags.filter(item => item.checked).map(item => item.id)
                this.statusCountry = canceldata.country
                this.SDate = canceldata.SDate
                this.EDate = canceldata.EDate
                this.currentTimezone = canceldata.timeZone
                this.pageSize = parseInt(canceldata.size)
                this.cancenData.timeZone = canceldata.timeZone
                this.dateRadioDefaultType = canceldata.dateRadioDefaultType
                this.cancenData = {
                  startTime:{
                    startDatetime:canceldata.startDatetime,
                    SDate:canceldata.SDate
                  },
                  endTime:{
                    endDatetime: canceldata.endDatetime,
                    EDate:canceldata.EDate
                  },
                  timeZone:canceldata.timeZone,
                  country:canceldata.country,
                  filteringMappStatus:canceldata.filteringMappStatus
                }

                this.startDatetime = canceldata.startDatetime
                this.endDatetime = canceldata.endDatetime
                this.setState({
                  settingTimeZone:canceldata.timeZone,
                  filteringMappStatus:canceldata.filteringMappStatus,
                  flagsList:canceldata.flags,
                  ateRadioDefaultType:canceldata.dateRadioDefaultType,
                  dateRadioDefaultType:canceldata.dateRadioDefaultType
                })
              }
            }

          }
          this.getStoreList(storeIdWithOrder); // 设置当前在那个店铺
        }
      }
    })
    
    window.changeUTC = true

    let isMove = true;
    var dom = document.getElementById("root");
    //按下标识
    let mouseFlag = false;

    dom.onclick = e => {
      let con = document.querySelector('#order_no_input_box')
      let con1 = document.querySelector('#filterText')
      let con2 = document.querySelector('#filterTextIcon')

      if(e.target.getAttribute('class') == 'ant-tooltip-open'){
        this.setState({
          searchFlag:true
        })
        return
      }
      if(e.target.getAttribute('id') == 'searchKey'){
        this.setState({
          searchFlag:true
        })
        return
      }

      if(typeof con?.contains === 'function'){
        if(e.target == con1 || e.target == con2){
          this.setState({
            searchFlag:true
          })
          return
        }
        if (!con?.contains(e.target) && isMove && !this.state.searchKey) {
          this.setState({
            searchFlag:false
          })
          if(e.target.getAttribute('id') != 'filterText' && e.target.getAttribute('class') != 'filterBox'){
            setTimeout(()=>{
              this.setState({
                searchFlagBtn:false,
                hidden:true
              })
            },600)
          }
        }
      }
    }

    dom.onmousemove = e => {
      if(mouseFlag){
        isMove = false
      }
    }

    dom.onmousedown = (e) => {
      mouseFlag = true
    }

    dom.onmouseup = (e) => {
      mouseFlag = false
      setTimeout(()=>{
        isMove = true
      },800)
    }

    if(this.searchKey){
      this.setState({
        searchFlag:true,
        searchFlagBtn: true,
        hidden: false
      })
    }
   
    this.setState({
      tutorial_type,
      attention:Boolean(localStorage.getItem('attention'))
    });

    const BasicLayoutContentById = document.getElementById(
      'BasicLayoutContentById'
    );
    // 从提示跳转过来时展示的默认table标签
    const parse = qs.parse(location.search.slice(1));
    if (parse.id && Object.keys(this.statusToCount).includes(parse.id)) {
      this.setState({
        status: parse.id
      });
      this.status = Number(parse.id);
    }

    //如果包含了orderKey 就不用请求了
    if(!window.location.href.includes('orderKey')){
      this.getStoreList(storeIdWithOrder);
    }

    this.getCountryList(); // 国家列表
      this.queryOrderResult(); // 查询下单结果 之前可能没查完用户离来了
    // this.getSettingMsg(); // setting中设置的订单信息
    this.getSettingMsgRetry(); // setting中设置的订单信息
    this.getAESyncCount(); // ae同步订单次数

    BasicLayoutContentById.addEventListener('scroll', this.handleScroll); // 滚动监听 是否显示定位在页面中间的下单按钮
    if (localStorage.getItem('ProductID')) {
      this.productIdCount = localStorage.getItem('ProductID');
      this.searchKey = localStorage.getItem('ProductID');
      this.setState({
        searchKey: localStorage.getItem('ProductID')
      });
    }

    if (localStorage.getItem('ProductSta')) {
      this.changeTabStatus(6);
    }

    this.storeData = stores.filter(
      item =>
        item.shop_name !== 'Importlist' && item.shop_name !== 'Imported Orders'
    );

    webCustomCollect({
      action: 'enter_order',
      custom_info: []
    });

    //监听更新物流事件
    window.EVENT.on(OrderAction.UPDATE_FRIENGHT, async res => {
      const { oid, sp,isBindWay, ...reset } = res;
      window.EVENT.emit(OrderAction.CLOSE_FRIENGHT_MODAL, false);
      let product = await fetchProductInfo(reset);
      if (product.data.result) {
        let data = product.data.result;
        if (
         ( data?.webEnv?.country !== sp.country_code ||
          data?.webEnv?.currency !== 'USD') && !isBindWay
        ) {
          captureException(
            `UPDATE_FREIGHT_ERROR: id:${reset.id};c:${sp.country_code};getC:${data?.webEnv?.country};getT:${data?.webEnv?.currency}`
          );
          return;
        }

        const ext = {};
        // 商品重定向为美国商品Id以后 修正数据以更新原Id数据
        if(data?.pageModule?.productId && `${data?.pageModule?.productId}` !== `${reset.id}` && !isBindWay) {
          ext.redirectId = data.pageModule.productId;
          const id = Number(reset.id);
          data.pageModule.productId = id;
          if(data?.actionModule) {
            data.actionModule.productId = id;
          }
        }
        
        this.getFreightProductData({
          data: data,
          country: isBindWay ? reset.country : sp.country_code,
          currency: 'USD',
          language: 'en',
          isBindWay:isBindWay,
          ext
        });
      }
    });

    
  }
    

  componentDidUpdate(prevProps, prevState) {
    const {
      storeIdWithOrder,
      order: { orderData },
      settingTimeZone
    } = this.props;
    const { status, orderList } = this.state;
    if (storeIdWithOrder !== prevProps.storeIdWithOrder) {
      this.changeStore(storeIdWithOrder);
    }
    if (prevProps.order.orderData !== orderData && [2, 7].includes(status)) {
      this.handleBannerCheck(orderData);
    }

    if (
      prevState.orderList !== orderList &&
      orderList &&
      orderList.length > 0 &&
      status === 2
    ) {
      // 通知 guide
      dispatchEventForGuide({
        type: 'order',
        payload: { category: 'rendered', data: orderList[0] }
      });
    }
  }

  componentWillUnmount() {
    clearInterval(this.syncCanceledTimer); // 清除定时器
    clearTimeout(this.fulfillTipTimer);
    clearInterval(this.queryOrderResultTimer);
    clearInterval(this.syncFulfillmentTimer);
    clearInterval(this.scrollTimer);
    clearInterval(this.refreshLocalAETimer);
    this.process = true
  }

  CouputedTime = (time) => {
		if(/(\d*)-(\d*)-(\d*)/g.test(time)){
			return RegExp.$1 + '-' + RegExp.$2 + '-' + Number(RegExp.$3)
		}
	}

  // 设置当前在那个店铺
  // eslint-disable-next-line
  getStoreList = async (id) => {
    const stores = this.props.userInfo.stores || [];
    let oneStore = null;
    let oneStoreId = 'all';

    oneStore = stores.find(store => this.cacheOrdersStoreId === store.id); // cacheOrdersStoreId localStlocalstorage存的order页店铺id
    oneStoreId = oneStore ? oneStore.id : oneStoreId; // 能找到缓存的店铺就用缓存 没有就默认all(所有店铺)

    localStorage.setItem('currentOrdersStoreId', oneStoreId);

    // 更新redux中的store id
    console.log('storeId值为', oneStoreId, id)
    if (oneStoreId !== id) {
      this.props.dispatch({
        type: 'global/updateOrderStoreId',
        payload: oneStoreId
      });
    }

    let TimeZone;
    if(this.props.settingTimeZone){
      TimeZone = timezone.filter(item => item.label == this.props.settingTimeZone)[0]
    }

    // 有没有缓存时区
    // const orderTimeZone = localStorage.getItem(
    //   `timezone${this.props.userInfo.user_id}`
    // );
    var timeZZ = Intl.DateTimeFormat().resolvedOptions().timeZone;

    let orderTimeZone = TimeZone?.value || timeZZ;
    // 有时区 在getUTCStartEnd里设置完时区时间 再获取订单列表
    if (orderTimeZone && orderTimeZone.includes('/')) {
      this.currentTimezone = orderTimeZone;
      this.getUTCStartEnd(orderTimeZone);
      return;
    }
    // 没时区 直接获取订单列表
    this.getOrderList();
  };

  getFreightProductData = async params => {
    try {
      const res = await Put('/prod/freight/refresh_product', {
        data: params
      });
      if (res.code === 2000) {
        if(params.isBindWay){
          window.EVENT.emit(OrderAction.UPDATA_SHIPPING, true)
        }else{
          this.getOrderList();
        }
      }
    } catch (error) {
      throw new Error(error);
    }
  };

  // 修正store id
  setStoreId = () => {
    const currentOrdersStoreId =
      localStorage.getItem('currentOrdersStoreId') || 'all';

    localStorage.setItem(
      'storeId',
      currentOrdersStoreId === 'all' ? '' : currentOrdersStoreId
    );
  };

  // 页面滚动是否显示批量下单按钮
  handleScroll = event => {
    const {
      global: { isBanner }
    } = this.props;

    // 🤢 🤢 🤢 🤢 有render卡顿问题 无法防抖 暂时支持业务这么写 后期有时间再改

    let scrollTop = 328;

    if (isBanner) {
      scrollTop = 492;
    }

    if (event.target.scrollTop <= scrollTop) {
      this.setState({
        isFixed: false
      });
    }

    if (event.target.scrollTop >= scrollTop) {
      if (event.target.scrollTop <= scrollTop) {
        return;
      }
      this.setState({
        isFixed: true
      });

      let cam_dom = document.getElementById('camtitleIds')
      let fixed_visitle = document.querySelector('.fixed_visitle')
      let fiex_backsq = document.querySelector('.fiex_backsq')
      let fixed_visitle_left = document.querySelector('.border_left')
      let fixed_visitle_right = document.querySelector('.border_right')
      if(cam_dom){
        if(fixed_visitle && fiex_backsq && fixed_visitle_left && fixed_visitle_right){
          fixed_visitle.style.top = '120px';
          fiex_backsq.style.top = '110px';
          fixed_visitle_left.style.display = 'none';
          fixed_visitle_right.style.display = 'none';
        }
      }
    }

    clearTimeout(this.scrollTimer);
    this.scrollTimer = setTimeout(() => {
      const { scrollTop } = event.target;
      const flag = this.getSelectedCanOrder();

      if (flag && scrollTop > 240) {
        this.setState({
          showGlobalPlaceOrder: true
        });
      }

      if (flag && scrollTop <= 240) {
        this.setState({
          showGlobalPlaceOrder: false
        });
      }
    }, 500);
  };

  // 获取setting中的手机号和用户留言
  getSettingMsg = () => {
    this.props.dispatch({
      type: 'order/orderSetting',
      payload: {
        callback: d => {
          if (d.code === 2000) {
            localStorage.setItem('settingOrderData', JSON.stringify(d.data));
          }
        }
      }
    });
  };

  getSettingMsgRetry = async () => {
    let success = false;
    for(let i = 0; i < 3; i++) {
      try {
        const res = await new Promise((resolve, reject) => {
          this.props.dispatch({
            type: 'order/orderSetting',
            payload: {
              callback: resolve,
              exceptionFn: reject
            }
          });
        });
        console.log(res);
        if(res?.code === 2000 && res?.data) {
          success = true;
          localStorage.setItem('settingOrderData', JSON.stringify(res.data));
          break;
        }
      } catch (error) {
        console.log(error);
      }
    }
    if(!success) {
      console.log('Fetch Order Setting Failed');
      captureException(new Error('Fetch Order Setting Failed'));
    }
  }

  // 获取国家列表
  getCountryList = () => {
    const countryList = localStorage.getItem('countryList');
    if (countryList) {
      this.countryLists = JSON.parse(countryList);
    }
  };

  setCursor = (Orders = {}) => {
    const { cursor = '', orders = [] } = Orders;
    this.cursor[this.currentPage + 1] = cursor;
    this.listLength = orders.length;
  };

  setListMap = list => {
    list.forEach(item => {
      this.listMap[item.id] = item; // 根据订单id生成的订单列表map
    });
    this.originListMap = cloneDeep(this.listMap); // 存一份开始数据
  };

  // 设置订单总个数
  setCount = (data = {}) => {
    const { Orders = {} } = data;
    this.count = Orders.count || 0;
  };

  // 获取插件下单内部进度
  getExtensionPlaceProcess = () => {
    this.refs.extensionProcess.startProcess();
  };

  // 获取order列表
  getOrderList = () => {
    const { filteringMappStatus } = this.cancenData
    const {
      userInfo: { user_id },
    } = this.props;

    let Status = {
      1:0,
      2:1,
      3:2
    }

    this.getSplitOrderData();

    this.setState({
      selectedRows: [],
      selectedRowsId: []
    });
    
    let flags = this.state.flagsList
      .filter(item => item.checked == true)
      .map(item => item.id);

    let params = {
      size: this.pageSize,
      cursor: this.cursor[this.currentPage],
      keywords: encodeURIComponent(this.searchKey),
      search_type: this.searchType,
      start_at: this.startDatetime,
      end_at: this.endDatetime,
      status: this.status,
      fulfilled: this.fulfilledBy,
      supply_platform:4,
      source: this.sourceBy,
      canceled: this.cancelBy,
      sort: this.sortBy,
      skip: '',
      flags: [...new Set(this.cancelIndex)],
      sel_fields: [
        '_id',
        'detail',
        'ext',
        'shopify_created_at',
        'store_id',
        'is_delete'
      ],
      key: '',
      country: this.statusCountry,
      untimeliness: true
    };

    //定制化用户的话拼接参数
    if(CUSTOMIZATION_USER.includes(user_id)){
      params = Object.assign(params, {mapping_type:Status[filteringMappStatus.id]})
    }

    //兼容后台读写分离优化
    if (window?.UPDATA_EXT) {
      delete params.untimeliness;
      window.UPDATA_EXT = false;
    }

    if (window?.UPDATE_CHANGE) {
      let UPDATE_TIME = parseInt(window.UPDATA_EXT_TIME / 1000);
      if (!parseInt(+new Date()) / 1000 - UPDATE_TIME > 15) {
        params.untimeliness = true;
        window.UPDATE_CHANGE = false;
      }
    }

    if (window.DS_BEGINNER_GUIDE_ACTIVE) {
      Object.assign(params, { is_tutorial: 1 });
    }

    this.setStoreId(); // 更新localStorage中的storeId (大部分请求storeId是在header中的 从localStorage取)

    this.props.dispatch({
      type: 'order/list',
      payload: {
        data: params,
        callback: d => {
          this.hasBulkEdit = false;
          if (d.code === 2000) {
            const originalOldOrderList = cloneDeep(d.data.Orders.orders);
            this.originalOldOrderMap = (originalOldOrderList || []).reduce(
              (prev, current) => {
                prev[current.id] = current;
                return prev;
              },
              {}
            );
            this.setState({
              oldOrderList:cloneDeep(d.data.Orders.orders)
            })

            this.removedVariants = d.data.Variants || {}; // 在shopify上删除的varaints id
            this.setCount(d.data); // 这是当前状态订单数量 翻页用
            this.setCursor(d.data.Orders); // 设置翻页游标 翻页用

            // 处理订单数据
            const list = getOrderShowData(
              d.data,
              this.status, // 订单在那个tab下 pending 还是 awating order
              this.state.types, // 用户付费等级
              this.props.userInfo,
              this.props.timezoneRegion // setting->report页设置的时区
            );

            //拆分订单逻辑
            list.map(item => {
              this.state.orderSplitData.map(itemL => {
                if (item.detail.id == itemL.sp_order_id) {
                  item.bStatus = itemL.status;
                  item.bMsg = itemL.msg;
                }
              });
            });

            this.listMap = {};
            this.originListMap = null;
            this.setListMap(list);
            const { userInfo, admitadCheckCode, localAEInfo } = this.props;
            try {
              const affiliateStatus = localAEInfo?.affiliateStatus;
              if ([2, 6, 7].includes(this.status)) {
                createCashBackTask(
                  userInfo,
                  admitadCheckCode,
                  list,
                  affiliateStatus,
                  localAEInfo
                );
              }
            } catch (error) {
              console.log(error);
            }
            // other单
            const otherData = this.Unique(
              this.getOtherData(list),
              'variant_id'
            );
            this.getOtherImage(otherData, list); // 获取other订单的图片

            this.setState({
              orderList: list
            });
            this.getCount(); // 获取各个tab下的订单数量
            
            // this.sendEmptyOrders(list); // 如果有空白单发送给后台
          }
        }
      }
    });
  };

  callLogServiceForBlankOrder = data => {
    if (!data) return;
    this.props.dispatch({
      type: 'topBtn/emptyorders',
      payload: {
        data,
        cancelMessage: true
      }
    });
  };

  // 获取other图片
  getOtherImage = (data, list) => {
    if (data.length > 0) {
      this.props.dispatch({
        type: 'order/getOtherImages',
        payload: {
          data,
          callback: d => {
            if (d.code === 2000 || d.code === 2010) {
              list.forEach(item => {
                item.childrens.forEach(child => {
                  Object.entries(d.data).forEach(items => {
                    if (Number(child.variantId) === Number(items[0])) {
                      if (items[1]) {
                        child.useSp.sku_img = items[1];
                      }
                    }
                  });
                });
              });
              this.forceUpdate();
            }
          }
        }
      });
    }
  };

  // 数组对象去重
  Unique(arr, name) {
    const hash = {};
    return arr.reduce((item, next) => {
      hash[next[name]] ? '' : (hash[next[name]] = true && item.push(next));
      return item;
    }, []);
  }

  getOtherData = data => {
    const arr = [];
    data.forEach(item => {
      item.childrens.forEach(item1 => {
        if (
          item1.shopifyProductId &&
          !item1.useSp.platform_product_id &&
          !item1.useSp.sku_img
        ) {
          const obj = {
            id: item1.shopifyProductId,
            variant_id: item1.variantId,
            store_id: item1.storeId
          };
          arr.push(obj);
        }
      });
    });
    return arr;
  };

  // 获取各个订单状态的数量
  getCount = () => {
    // return
    this.setStoreId();

    const { filteringMappStatus } = this.cancenData
    const {
      userInfo: { user_id },
    } = this.props;

    let Status = {
      1:0,
      2:1,
      3:2
    }

    let flags = this.cancelFlags
      .filter(item => item.checked == true)
      .map(item => item.id);

    let params = {
      supply_platform: 4,
      last: '',
      keywords: encodeURIComponent(this.searchKey),
      search_type: this.searchType,
      start_at: this.startDatetime,
      end_at: this.endDatetime,
      status: this.status,
      fulfilled: this.fulfilledBy,
      flags: flags,
      source: this.sourceBy,
      canceled: this.cancelBy,
      sort: this.sortBy,
      skip: '',
      sel_fields: [
        '_id',
        'detail',
        'ext',
        'shopify_created_at',
        'store_id'
      ],
      key: '',
      country: this.statusCountry,
      untimeliness: true
    }

    if(CUSTOMIZATION_USER.includes(user_id)){
      params = Object.assign(params, { mapping_type:Status[filteringMappStatus.id]})
    }


    this.props.dispatch({
      type: 'order/count',
      payload: {
        data: params,
        callback: d => {
          if (d.code === 2000) {
            this.countObj = d.data;
            this.cancenCount = cloneDeep(this.countObj)
            // localStorage.removeItem('selectStore')
          }
        }
      }
    });
  };

  // 显示刷新遮罩
  showRefreshMask = () => {
    this.setState({
      showRefreshMask: true
    });
  };

  // 链接ae
  linkAe = () => {
    if (
      localStorage.getItem('aliExpressAuthStatus') == 'true' &&
      localStorage.getItem('aliBeOverdueTime') > 0
    ) {
      this.showRefreshMask();
      this.hideAddModal();
      window.open(
        'https://home.aliexpress.com/dropshipper/join_drop_shipper.htm',
        '_blank'
      );
      return;
    }

    if (localStorage.getItem('aliBeOverdueTime') == null) {
      this.bindAE();
    } else {
      this.unBindAE();
    }
  };

  // 获取绑定ae链接
  bindAE = () => {
    this.props.dispatch({
      type: 'topBtn/aliauth',
      payload: {
        cancelMessage: true,
        callback: d => {
          if (d.code === 2000) {
            window.location.href = d.data.url;
          } else if (d.code === 4090) {
            window.location = '/app/';
          } else {
            message.error(d.msg);
          }
        }
      }
    });
  };

  // 解绑ae
  unBindAE = () => {
    this.props.dispatch({
      type: 'topBtn/unbind',
      payload: {
        cancelMessage: true,
        callback: d => {
          if (d.code === 2010 || d.code === 2000) {
            this.bindAE();
          }
        }
      }
    });
  };

  deleteSearchKey = () => {
    this.searchKey = '';
    this.setState({
      searchKey: ''
    });
    this.changeSearch();
  };

  changeSearchKey = e => {
    this.searchKey = e.target.value;
    this.setState({
      searchKey: e.target.value,
    });
  };

  changeSearch = () => {
    this.currentPage = 1;

    this.setState({
      selectedRows: [],
      // searchFlag:false
    });

    window.UPDATE_CHANGE = true;

    this.getOrderList();

    reactGaEvent({
      category: 'Order',
      action: 'search'
    });

    const {
      userInfo: { user_id }
    } = this.props;
    CommonDataCollect({
      user_id: user_id,
      event_type: 'subscription_analysis',
      action: 'search_order'
    });
  };

  changeDatetime = m => {
    this.startDatetime = m[0].startOf('day').unix();
    this.endDatetime = m[1].endOf('day').unix();

    this.SDate = `${m[0].year()}-${m[0].month() + 1}-${m[0].date()}`;
    this.EDate = `${m[1].year()}-${m[1].month() + 1}-${m[1].date()}`;

    this.momentFormatTime = m;
    this.currentPage = 1;

    this.setState({
      selectedRows: []
    });

    if (!(this.currentTimezone === null)) {
      this.getUTCStartEnd(this.currentTimezone);
      return;
    }

    const {
      userInfo: { user_id }
    } = this.props;
    CommonDataCollect({
      user_id: user_id,
      event_type: 'subscription_analysis',
      action: 'time_search_orders'
    });

    this.getOrderList();
  };

  // 改时区
  changeUTC = v => {
    console.log('v的值为', v)
    this.setState({
      settingTimeZone:v
    })
    window.changeUTC = false;
    if (v === undefined) {
      localStorage.removeItem(`timezone${this.props.userInfo.user_id}`);
      localStorage.removeItem(`timezoneV${this.props.userInfo.user_id}`);
      this.currentTimezone = null;

      if (this.momentFormatTime) {
        this.startDatetime = this.momentFormatTime[0]
          ? this.momentFormatTime[0].startOf('day').unix()
          : '';
        this.endDatetime = this.momentFormatTime[1]
          ? this.momentFormatTime[1].endOf('day').unix()
          : '';
      } else {
        this.startDatetime = moment()
          .subtract(30, 'days')
          .startOf('day')
          .unix();
        this.endDatetime = moment()
          .endOf('day')
          .unix();
      }

      this.getOrderList();
      return;
    }

    if (v !== undefined) {
      const {
        userInfo: { user_id }
      } = this.props;
      CommonDataCollect({
        user_id: user_id,
        event_type: 'subscription_analysis',
        action: 'time_search_orders'
      });
    }

    localStorage.setItem(`timezone${this.props.userInfo.user_id}`, v); // 用户选的时区要存下来 下次登陆还用这个
    this.currentTimezone = v;
    this.getUTCStartEnd(v);
  };

  fixedZero = val => {
    return val * 1 < 10 ? `${val}0` : val;
  };
  
  // 获取用户选择的时区的开始结束时间
  getUTCStartEnd = (zone, flag = true, flag2 = false) => {
    const { dataType, dateRadioDefaultType } = this.state
    if(CUSTOMIZATION_USER.includes(this.props.userInfo.user_id) && !flag2){
      let data = JSON.parse(localStorage.getItem('CUSTOMIZATION_USER_ACTION_V3'));
      if(data){
        this.startDatetime = data.startDatetime
        this.endDatetime = data.endDatetime  
        this.getOrderList();
      }
      return
    }

    if(!this.isSelectDate){
      this.getOrderList();
      return
    }

    const diffMinute = moment().tz(zone).utcOffset() - moment()?.utcOffset();
    this.startDatetime = moment(this.SDate).unix() - diffMinute * 60;
    this.endDatetime = moment(this.EDate).endOf('day').unix() - diffMinute * 60;

    this.setState({
      selectedRows: []
    });
    
    localStorage.setItem('CUSTOMIZATION_USER_ACTION_V3',JSON.stringify({
      EDate:this.cancenData.endTime.EDate,
      SDate:this.cancenData.startTime.SDate,
      timeZone:this.cancenData.timeZone,
      startDatetime:this.startDatetime,
      endDatetime:this.endDatetime,
      dateRadioDefaultType:this.dateRadioDefaultType,
      filteringMappStatus:this.cancenData.filteringMappStatus,
      country:this.cancenData.country,
      flags:this.cancelFlags,
      size:this.pageSize
    }))
    

    if(window.location.href.includes('orderKey') && DEFAULT_SEARCH_TIME){
      let startDatetime = getQueryUrlParams(window.location.href, 'start_at');
      let endDatetime = getQueryUrlParams(window.location.href, 'end_at')
      this.startDatetime = Number(startDatetime)
      this.endDatetime = Number(endDatetime)
      DEFAULT_SEARCH_TIME = false
      this.getOrderList();
      return
    }else{
      if(flag){
        this.getOrderList();
      }
    }
  };

  getCusUTCStartEnd = (zone) => {

    const { dataType, dateRadioDefaultType } = this.state
    let cancelData = JSON.parse(localStorage.getItem('CUSTOMIZATION_USER_ACTION_V3'))
    let dataObj = dataType.find(item => item.type == dateRadioDefaultType)

    if(dateRadioDefaultType == 1){
      this.startDatetime = parseInt(moment().startOf('day').valueOf() / 1000)
      this.endDatetime = parseInt(moment().endOf('day').valueOf() / 1000)
      localStorage.setItem('cusData',JSON.stringify({
        startDatetime:this.startDatetime,
        endDatetime:this.endDatetime
      }))
      const dateFormat = 'YYYY-M-DD';
      let startDatetime = moment(this.startDatetime * 1000).format('YYYY-MM-DD')
      let endDatetime = moment(this.endDatetime * 1000).format('YYYY-MM-DD')

      localStorage.setItem('CUSTOMIZATION_USER_ACTION_V3', JSON.stringify({
        EDate: endDatetime,
        SDate: startDatetime,
        timeZone:this.cancenData.timeZone,
        startDatetime:this.startDatetime,
        endDatetime:this.endDatetime,
        filteringMappStatus:this.cancenData.filteringMappStatus,
        country:this.cancenData.country,
        flags:this.cancelFlags,
        size:this.pageSize,
        dateRadioDefaultType: this.state.dateRadioDefaultType
      }))
    }
    if(dateRadioDefaultType == 2){
      this.startDatetime = parseInt(moment().subtract(dataObj.timestamp, 'days').valueOf() / 1000)
      this.endDatetime = parseInt(moment().valueOf() / 1000)
      localStorage.setItem('cusData',JSON.stringify({
        startDatetime:this.startDatetime,
        endDatetime:this.endDatetime
      }))
      
      const dateFormat = 'YYYY-M-DD';
      let startDatetime = moment(this.startDatetime * 1000).format('YYYY-MM-DD')
      let endDatetime = moment(this.endDatetime * 1000).format('YYYY-MM-DD')

      localStorage.setItem('CUSTOMIZATION_USER_ACTION_V3', JSON.stringify({
        EDate: endDatetime,
        SDate: startDatetime,
        timeZone:this.cancenData.timeZone,
        startDatetime:this.startDatetime,
        endDatetime:this.endDatetime,
        filteringMappStatus:this.cancenData.filteringMappStatus,
        country:this.cancenData.country,
        flags:this.cancelFlags,
        size:this.pageSize,
        dateRadioDefaultType: this.state.dateRadioDefaultType
      }))
    }
    if(dateRadioDefaultType == 3){
      const diffMinute = moment().tz(zone).utcOffset() - moment()?.utcOffset();
      let cancelData = JSON.parse(localStorage.getItem('actionStatus_v3'))
      this.startDatetime = moment(cancelData.SDate).unix() - diffMinute * 60;
      this.endDatetime = moment(cancelData.EDate).endOf('day').unix() - diffMinute * 60;
      localStorage.setItem('cusData',JSON.stringify({
        startDatetime:this.startDatetime,
        endDatetime:this.endDatetime
      }))
      
      const dateFormat = 'YYYY-M-DD';
      let startDatetime = moment(this.startDatetime * 1000).format('YYYY-MM-DD')
      let endDatetime = moment(this.endDatetime * 1000).format('YYYY-MM-DD')

      localStorage.setItem('CUSTOMIZATION_USER_ACTION_V3', JSON.stringify({
        EDate: endDatetime,
        SDate: startDatetime,
        timeZone:this.cancenData.timeZone,
        startDatetime:this.startDatetime,
        endDatetime:this.endDatetime,
        filteringMappStatus:this.cancenData.filteringMappStatus,
        country:this.cancenData.country,
        flags:this.cancelFlags,
        size:this.pageSize,
        dateRadioDefaultType: this.state.dateRadioDefaultType
      }))
    }
    if(dateRadioDefaultType == 4){
      this.startDatetime = parseInt(moment(cancelData?.eDate).subtract(dataObj.timestamp, 'days').valueOf() / 1000)
      this.endDatetime = parseInt(moment(cancelData?.eDate).valueOf() / 1000)
      localStorage.setItem('cusData',JSON.stringify({
        startDatetime:this.startDatetime,
        endDatetime:this.endDatetime
      }))
      
      const dateFormat = 'YYYY-M-DD';
      let startDatetime = moment(this.startDatetime * 1000).format('YYYY-MM-DD')
      let endDatetime = moment(this.endDatetime * 1000).format('YYYY-MM-DD')

      localStorage.setItem('CUSTOMIZATION_USER_ACTION_V3', JSON.stringify({
        EDate: endDatetime,
        SDate: startDatetime,
        timeZone:this.cancenData.timeZone,
        startDatetime:this.startDatetime,
        endDatetime:this.endDatetime,
        filteringMappStatus:this.cancenData.filteringMappStatus,
        country:this.cancenData.country,
        flags:this.cancelFlags,
        size:this.pageSize,
        dateRadioDefaultType: this.state.dateRadioDefaultType
      }))
      
    }
    if(dateRadioDefaultType == 5){
      this.startDatetime = parseInt(moment(cancelData.eDate).subtract(dataObj.timestamp, 'days').valueOf() / 1000)
      this.endDatetime = parseInt(moment(cancelData.eDate).valueOf() / 1000)
      localStorage.setItem('cusData',JSON.stringify({
        startDatetime:this.startDatetime,
        endDatetime:this.endDatetime
      }))
      
      const dateFormat = 'YYYY-M-DD';
      let startDatetime = moment(this.startDatetime * 1000).format('YYYY-MM-DD')
      let endDatetime = moment(this.endDatetime * 1000).format('YYYY-MM-DD')

      localStorage.setItem('CUSTOMIZATION_USER_ACTION_V3', JSON.stringify({
        EDate: endDatetime,
        SDate: startDatetime,
        timeZone:this.cancenData.timeZone,
        startDatetime:this.startDatetime,
        endDatetime:this.endDatetime,
        filteringMappStatus:this.cancenData.filteringMappStatus,
        country:this.cancenData.country,
        flags:this.cancelFlags,
        size:this.pageSize,
        dateRadioDefaultType: this.state.dateRadioDefaultType
      }))
    }

    this.getOrderList();
  }

  // 改变商店
  changeStore = value => {
    window.ISFLAG = value;
    localStorage.setItem('currentOrdersStoreId', value);
    this.currentPage = 1;
    this.setState({
      selectedRows: []
    });
    this.getOrderList();
  };

  // 改变页码
  changePager = flag => {
    this.currentPage =
      flag === 'prev' ? this.currentPage - 1 : this.currentPage + 1;
    this.setState({
      selectedRows: []
    });
    this.getOrderList();
    this.goTop();
  };

  // 改变一页显示数量
  changePageSize = v => {
    if(CUSTOMIZATION_USER.includes(this.props.userInfo.user_id)){
      let data = JSON.parse(localStorage.getItem('CUSTOMIZATION_USER_ACTION_V3'));
      localStorage.setItem('CUSTOMIZATION_USER_ACTION_V3', JSON.stringify({
        ...data,
        size:parseInt(v)
      }))
    }
    this.pageSize = parseInt(v);
    this.currentPage = 1;
    this.cursor = { 1: '' };
    this.getOrderList();
    this.goTop();
  };

  goTop = () => {
    const anchorElement = document.getElementById('orderBox');
    if (anchorElement) {
      anchorElement.scrollIntoView({
        block: 'start',
        behavior: 'smooth'
      });
    }
  };

  listLength = 0; // 这一页订单数量

  cursor = { 1: '' }; // 翻页游标

  currentPage = 1; // 当前页

  canceldata = JSON.parse(localStorage.getItem('CUSTOMIZATION_USER_ACTION_V3'));

  pageSize = Number(this.canceldata?.size) || 40; // 一页多少条

  searchKey = ''; // 搜索内容

  isSelectDate = false;

  startDatetime = moment()
    .subtract(30, 'days')
    .startOf('day')
    .unix();

  endDatetime = moment()
    .endOf('day')
    .unix();

  SDate = `${moment()
    .subtract(30, 'days')
    .year()}-${moment()
    .subtract(30, 'days')
    .month() + 1}-${moment()
    .subtract(30, 'days')
    .date()}`;

  EDate = `${moment().year()}-${moment().month() + 1}-${moment().date()}`;

  momentFormatTime = undefined;

  status = 2; // 默认tab awaiting order

  countryLists = [];

  productMap = {}; // 没用到

  productIdCount = '';

  statusCountry = ''; // 按国家刷选订单

  cancelBy = 0; // 谁取消的

  fulfilledBy = 0; // 谁完成的

  sortBy = 0; // 排序

  sourceBy = 0; // fulfilled tab 下source的值

  searchType = 1; // 搜索类型 搜订单号 还是产品名

  hasBulkEdit = false; // 换绑保存时 是否有的是 批量换绑

  currentTimezone = null; // 当前时区

  count = 0; // 订单总个数

  // 点击复选框
  handleSelectRows = rows => {
    const { filteringMappStatus,orderList, status } = this.state
    let bool = filteringMappStatus.hasOwnProperty('id') && filteringMappStatus?.id != 1
    let filterMappingOrderList  = [];
    if(bool){
      const orderList2 = this.setOrderDisabled(orderList, status); // 订单是否可选 是否可下单
    
      if([2,3].includes(filteringMappStatus?.id)){
        filterMappingOrderList = this.filt(orderList2, status)
      }
    }

    if (rows.target.checked) {
      this.setState(
        {
          selectedRows: bool ? filterMappingOrderList : [...this.state.orderList]
        },
        () => {
          this.setState({
            selectedRowsId: this.state.selectedRows.map(item => item.id)
          });
        }
      );
    } else {
      this.setState(
        {
          selectedRows: []
        },
        () => {
          this.setState({
            selectedRowsId: this.state.selectedRows.map(item => item.id)
          });
        }
      );
    }

    //侧边栏广告全选展示逻辑
    // if(rows.target.checked && JSON.stringify(this.state.bannerData) !== '{}'){
    //   let haveData = false
    //   this.state.orderList.forEach(item=>{
    //     item.childrens.forEach(item=>{
    //       if(item.shopifyProductId === this.state.bannerData?.shopify_product_id){
    //         haveData = true
    //       }
    //     })
    //   })
    //   if(haveData){
    //     this.props.dispatch({  //如果全选并且有竞品展开一半
    //       type:'global/showHalfBanner'
    //     })
    //   }
    // }else{
    //   let haveData = false
    //   this.state.orderList.forEach(item=>{
    //     item.childrens.forEach(item=>{
    //       if(item.shopifyProductId === this.state.bannerData?.shopify_product_id){
    //         haveData = true
    //       }
    //     })
    //   })
    //   if(haveData){
    //     this.props.dispatch({
    //       type:'global/drawerBannerNoVisible'
    //   })
    //     this.props.dispatch({
    //       type:'global/closeHalfBanner'
    //     })
    //   }
    // }
  };

  arr = [];
  onChangeChecked = (val, list) => {
    console.log(val, list, this.state.bannerData);
    if (val.target.checked) {
      this.arr.push(list);
      this.setState(
        {
          selectedRows: [...this.state.selectedRows, ...this.arr]
        },
        () => {
          this.arr = [];
          this.setState({
            selectedRowsId: this.state.selectedRows.map(item => item.id)
          });
        }
      );
    } else {
      let arr = this.state.selectedRows;
      //过滤当前存在的。
      this.setState(
        {
          selectedRows: arr.filter(item => item.id != list.id)
        },
        () => {
          this.setState({
            selectedRowsId: this.state.selectedRows.map(item => item.id)
          });
        }
      );
    }

    // let goodExist=false //竞品是否存在的字段
    // list.childrens.forEach(item=>{
    //   if(item.shopifyProductId === Number(Object.keys(this.state.bannerData)[0])){
    //     goodExist=true   //如果存在就设为true
    //   }
    // })
    // if(val.target.checked && goodExist){
    //   this.props.dispatch({  //如果选中并且有竞品展开一半
    //     type:'global/showHalfBanner'
    //   })
    // }else if(!val.target.checked && goodExist){  //如果选灭并且选灭的是竞品则关闭
    //   this.props.dispatch({
    //     type:'global/drawerBannerNoVisible'
    // })
    //   this.props.dispatch({
    //     type:'global/closeHalfBanner'
    //   })
    // }
  };

  getSplitOrderData = async () => {
    try {
      const res = await Get('/ord/splitorder');
      if (res.code === 2000 && res.data) {
        this.setState({
          orderSplitData: res.data
        });
      }
    } catch (error) {
      console.log('paypalPremissionsError', error);
    }
  };
  
  // 切换tab订单状态
  changeTabStatus = key => {
    this.setState({changetab:Number(key)})

    const value = Number(key);

    if (value !== 5) {
      this.fulfilledBy = 0;
      this.sourceBy = 0;
    }

    if (value !== 6) {
      this.cancelBy = 0;
    }

    if (value === 7 || value === 3) {
      this.sortBy = 0;
    }

    this.currentPage = 1;
    this.status = value;

    console.log('tab Key为', value);

    this.setState({
      status: value,
      orderList: [], // 重置
      selectedRows: []
    });

    this.getOrderList();
  };

  // 点击绑定ali
  LinkAliExpress = () => {
    const header = getAuthorityHeader();
    window.open(
      `${BASE_URL}/ali/auth/redirect?token=${header.Authorization}`,
      '_blank'
    );
  };

  getAliUrl = item => {
    return `https://www.aliexpress.com/item/product/${item.product_platfrom_id}.html`;
  };

  purchaseOneOrder = null; // 下一个单的数据

  purchaseList = []; // 需要下单的订单

  statusToCount = {
    '0': 'all',
    '1': 'pending',
    '2': 'awaiting_order',
    '3': 'awaiting_payment',
    '4': 'awaiting_shipment',
    '9': 'awaiting_fulfilled',
    '5': 'fulfilled',
    '6': 'canceled',
    '7': 'failed'
  };

  getOrderTabTitle = item => {
    // 获取tab标题
    const { filteringMappStatus, status, orderList } = this.state
    
    // if(filteringMappStatus.hasOwnProperty('id') && filteringMappStatus?.id != 1){
    //   const orderList2 = this.setOrderDisabled(orderList, status); // 订单是否可选 是否可下单
    //   //计算mappding订单
    //   let filterMappingOrderList = []

    //   if([2,3].includes(filteringMappStatus?.id)){
    //     filterMappingOrderList = this.filt(orderList2, status)
    //   }
    //   this.countObj[this.statusToCount[status]] = filterMappingOrderList.length
    // }else{
    //   this.countObj[this.statusToCount[status]] =  this.cancenCount[this.statusToCount[status]]
    // }
    this.countObj[this.statusToCount[status]] =  this.cancenCount[this.statusToCount[status]]
    const num = this.countObj[this.statusToCount[`${item[0]}`]]; // 当前搜索条件下 这个状态有多少订单
    return (
      <>
        {intl.getHTML('order.tab.title', { key: item[0] })}
        <b
          style={{ marginLeft: 5 }}
          className={className({
            [orderStyles.redColor]: item[1] === 'Failed orders' && num > 0
          })}
        >
          <br />
          {item[0] == 6 ? (
            <span className="chen">{`(${num})`}</span>
          ) : item[0] == 7 ? (
            <span className="chenX">{`(${num})`}</span>
          ) : (
            <>{`(${num})`}</>
          )}
        </b>
      </>
    );
  };

  showDeleteSearch = () => {
    // 鼠标经过搜索框是否展示删除图标
    if (this.searchKey) {
      this.setState({ showDeleteSearch: true });
    }
  };

  hideDeleteSearch = () => {
    // 鼠标离开搜索框隐藏删除图标
    this.setState({ showDeleteSearch: false });
  };

  fbdSupply = {};

  // 显示mapping
  showMapping = (child, storeId, oid) => {
    if (this.checkIsNewUserWithoutAe()) {
      window.EVENT.emit(OrderAction.IS_BIND_AE_MODAL, true);
      return;
    }

    if (!child.shopifyProductId) {
      message.error(intl.get('order.err_deleted_in_shopify'));
      return;
    }

    // 获取这个订单中的shopify商品详情
    this.props.dispatch({
      type: 'order/mapProd',
      payload: {
        data: {
          id: child.shopifyProductId,
          store_id: storeId
        },
        callback: d => {
          if (d.code === 2000) {
            if (d.data == '') {
              message.error(
                intl.getHTML('order.err_deleted_in_dsers', {
                  href:
                    'https://help.dsers.com/re-order-an-order-with-deleted-product-for-shopify/'
                })
              );
              return;
            }
            const data = d.data || {};
            const { prod = {}, supply = {} } = data;

            if (!prod.ext) {
              prod.ext = {};
            }

            const obj = {
              id: prod.id,
              image: prod.detail.image ? prod.detail.image.src : '',
              title: prod.detail.title,
              prod,
              variant: this.getRemovedVariantId(child, oid),
              // 从订单页打开mapping 禁用删除variant按钮
              deleteVariantButtonDisabled: true,
              orderVaraintId: child.variantId,
              ship_to: prod?.ship_to
            };

            this.fbdSupply = supply;
            this.setState({
              mappingProduct: obj,
              showMapping: true
            });

            dispatchEventForGuide({
              type: 'mapping',
              payload: { category: 'MAPPING_START' }
            });
          }
        }
      }
    });
    reactGaEvent({
      category: 'Order',
      action: 'mapping'
    });
  };

  // 隐藏mapping
  hideDeputySupplier = hasSave => {

    localStorage.removeItem('mapping_dot');
    this.setState({
      showMapping: false
    });

    // 更新mapping从新获取订单列表
    if (hasSave) {
      this.getOrderList();
    }
  };

  // 获取这个 variant 有没有删除
  getRemovedVariantId = (child, oid) => {
    const removeArr = this.removedVariants[oid];

    if (removeArr == undefined) {
      return undefined;
    }

    return removeArr.find(item => item.variant_id == child.variantId);
  };

  goSetting = () => {
    this.props.dispatch(routerRedux.push('/settings'));
  };

  syncCanceledTimer = null;

  aeSyncLoading = false;

  // 创建ae同步订单任务
  createAESyncJob = type => {
    // blerlo  未绑定AE用户 --Sync via API .. 5 more time(s) today) （已经有逻辑不重复展示）
    if (!window.IS_BIND_AE) {
      window.EVENT.emit(
        GuildeAction.OblerloGuide_Pop,
        `AE-${Date.now()}`,
        true
      );
      return;
    }
    // if(type == 1 && !window.CHROME_PLUG_INSTALL){
    //   window.EVENT.emit(ChromeAction.NO_INSTALL_MODAL, true)
    //   return
    // }

    const {
      userInfo: { user_id }
    } = this.props;
    CommonDataCollect({
      user_id: user_id,
      event_type: 'subscription_analysis',
      action: 'api_synchronization_ae_order'
    });

    this.props.dispatch({
      type: 'order/aeSyncJob',
      payload: {
        type,
        cancelMessage: true,
        callback: d => {
          if (d.code === 2010 || d.code === 2000) {
            this.aeSyncLoading = true;
            clearInterval(this.syncCanceledTimer);
            this.syncCanceledTimer = setInterval(this.getAESyncJobs, 5000);
          } else {
            message.error(
              d.code === 4090
                ? intl.get('order.ae_sync_not_done')
                : intl.get('order.ae_sync_more_then_5')
            );
            clearInterval(this.syncCanceledTimer);
          }
          this.getAESyncCount();
        }
      }
    });
  };

  // 获取同步ae次数
  getAESyncCount = () => {
    this.props.dispatch({
      type: 'order/getOrderAliSum',
      payload: {
        callback: d => {
          if (d.code === 2010 || d.code === 2000) {
            this.setState({
              sumSync: d.data.count || 0
            });
          }
        }
      }
    });
  };

  // 查询同步任务是否完成
  getAESyncJobs = () => {
    this.props.dispatch({
      type: 'order/jobAE',
      payload: {
        cancelMessage: true,
        callback: d => {
          if (d.code == 2000 && d.data.count == 0) {
            this.aeSyncLoading = false;
            clearInterval(this.syncCanceledTimer);
            this.getOrderList();
          }
        }
      }
    });
  };

  // 展示把订单改成fulfilled状态弹窗批量
  markMultipleFulfilled = () => {
    const { selectedRows } = this.state;
    this.fulfilledList = selectedRows;
    this.setState({
      showFulfilledModal: true,
      visibleFulfillOrdersManuallyTip: false
    });
    reactGaEvent({
      category: 'Order',
      action: 'markasfullfied_bulk'
    });
  };

  fulfilledList = []; // 去fulfilled的数据

  fulfilledChildId = ''; // 单个子订单fulfilled的id

  // 把单个订单改成fulfilled状态弹窗
  markAsFulfilled = (oid, childId) => {
    this.fulfilledList = [this.listMap[oid]];
    this.fulfilledChildId = childId;

    this.setState({
      showFulfilledModal: true
    });

    reactGaEvent({
      category: 'Order',
      action: 'markasfullfied_single'
    });
  };

  // 隐藏设置fulfilled弹窗
  hideFulfilledModal = hasSave => {
    this.fulfilledChildId = '';
    if (hasSave) {
      this.setState({
        selectedRows: [],
        showFulfilledModal: false
      });
      this.getOrderList();
    } else {
      this.setState({
        showFulfilledModal: false
      });
    }
  };

  // 展示回滚订单弹窗
  showRollBackOrders = () => {
    this.setState({
      showRollBack: true
    });
  };

  // 关闭回滚订单弹窗
  hideRollBackOrders = hasRollBack => {
    if (hasRollBack) {
      this.setState({
        showRollBack: false,
        selectedRows: []
      });
      this.getOrderList();
      // message
      //   .success(intl.get('order.roll_back_awaiting_shopify_hook_tip'))
      //   .then(() => {
      //     this.getOrderList();
      //   });
    } else {
      this.setState({
        showRollBack: false
      });
    }
  };

  // 手动触发Shopify的Fulfill
  syncFulfillment = () => {
    this.props.dispatch({
      type: 'order/syncFulfillment',
      payload: {
        callback: d => {
          if (d.code == 2000) {
            if (d.data.count != d.data.failed) {
              this.syncFulfillmentStatusLoading = true;
              this.querySyncFulfillmentStatus();
            } else {
              message.warning(`${d.data.failed} orders are partially fulfilled on DSers and can not fulfilled on Shopify yet. Once the tracking number appears on DSers, we will automatically trigger fulfillment on Shopify.
              We do this to avoid sending multiple Shipping Confirmation mail to your customers.`);
            }
          }
        }
      }
    });
  };

  syncFulfillmentTimer = null;

  syncFulfillmentStatusLoading = false;

  // 轮询手动触发Shopify的Fulfill是否完成
  querySyncFulfillmentStatus = () => {
    this.syncFulfillmentTimer = setInterval(
      this.getSyncFulfillmentStatus,
      6000
    );
  };

  // 查询手动触发Shopify的Fulfill是否完成
  getSyncFulfillmentStatus = () => {
    this.props.dispatch({
      type: 'topBtn/syncFulfillmentStatus',
      payload: {
        callback: d => {
          if (d.code == 2000 || d.code == 2010) {
            if (d.msg == 'success') {
              clearInterval(this.syncFulfillmentTimer);
              this.syncFulfillmentStatusLoading = false;
              if (this.state.status == 9) {
                this.getOrderList();
              }
            }
          }
        }
      }
    });
  };

  // 隐藏绑定ali卡片
  hideAddModal = () => {
    this.setState({
      bindAliCardShow: false
    });
  };

  getSelectedCanOrder = () => {
    // 获取选中的订单是否可以下单
    const { selectedRows, status } = this.state;
    const tabStatusArr = [2, 6, 7];
    let flag = false; // true可以下单
    selectedRows.forEach(item => {
      if (!item.canOrderDisabled) {
        flag = true;
      }
    });
    if (!tabStatusArr.includes(status)) {
      flag = false;
    }
    return flag;
  };

  getList = () => {
    this.currentPage = 1;
    this.getOrderList();
  };

  handleBannerCheck = async data => {
    const { Orders } = data;
    if (!(Orders && Orders.orders)) {
      return;
    }

    // eslint-disable-next-line
    const result = {};
    // eslint-disable-next-line
    for (const item of Orders.orders) {
      const countryCode = item?.ext?.address?.country_code;
      if (!countryCode) {
        continue;
      }
      // console.log(item)
      if (item.ext.lineitems.length) {
        if (!result[item.store_id]) {
          result[item.store_id] = [];
        }

        // eslint-disable-next-line
        for (const i of item.ext.lineitems) {
          const exsistProd = result[item.store_id].find(
            prod => prod.id === i.product_id
          );
          if (exsistProd) {
            if (!exsistProd.countries.includes(countryCode)) {
              exsistProd.countries.push(countryCode);
            }
            // eslint-disable-next-line
            continue;
          }
          result[item.store_id].push({
            id: i.product_id,
            countries: [countryCode]
          });
        }
      }
    }
    const storeIds = Object.keys(result);

    if (storeIds.length === 0) {
      return;
    }

    Promise.all(
      storeIds.map(i => {
        const params = {
          store_id: i,
          sp_product: result[i]
        };
        return Post('/prod/propool/check', {
          data: params
        });
      })
    )
      .then(res => {
        const goods = {};
        const exsistAliIds = {};
        res
          .filter(
            i => i.code === 2000 && i.data && Object.keys(i.data).length > 0
          )
          .map(i => i.data)
          .forEach(i => {
            // 每个ae供应商只展示一个广告
            Object.entries(i).forEach(([key, value]) => {
              if (!exsistAliIds[value?.ae_product_id]) {
                goods[key] = value;
                exsistAliIds[value?.ae_product_id] = true;
              }
            });
          });
        // console.log(goods)
        this.setState({ bannerData: goods });
        console.log('banner confirm =>>>>', goods);
        return null;
      })
      .catch(err => {
        console.log('handleBannerCheck fetch error:', err);
      });
  };

  changeStatusCountry = v => {
    // 按国家筛选订单
    this.statusCountry = v || '';
    this.setState({
      selectedRows: []
    });

    if (v !== undefined) {
      const {
        userInfo: { user_id }
      } = this.props;
      CommonDataCollect({
        user_id: user_id,
        event_type: 'subscription_analysis',
        action: 'country_search_orders'
      });
    }

    this.getList();
  };

  // fulfilled状态按谁fufilled的筛选
  changeStatusFulfilled = v => {
    this.fulfilledBy = v || 0;
    this.sourceBy = 0;
    this.setState({
      selectedRows: []
    });
    this.getList();
  };

  // fulfilled状态source筛选
  changeSource = v => {
    this.sourceBy = v || 0;
    this.fulfilledBy = 0;
    this.setState({
      selectedRows: []
    });
    this.getList();
  };

  // canceled状态按谁canceled的筛选
  changeStatusCanceled = v => {
    this.cancelBy = v || 0;
    this.setState({
      selectedRows: []
    });
    this.getList();
  };

  // 按时间排序筛选订单
  changeSort = v => {
    this.sortBy = this.sortBy == 0 ? 1 : 0;
    this.setState({
      selectedRows: []
    });
    this.getList();
  };

  // 清除订单筛选
  clearFilter = () => {
    this.sortBy = 0;
    this.fulfilledBy = 0;
    this.sourceBy = 0;
    this.cancelBy = 0;
    this.statusCountry = '';
    this.setState({
      selectedRows: []
    });
    this.getList();

    window.EVENT.emit(OrderAction.INTERACTION_DOT, {
      action:'click_refesh_order_icon',
      trans_from:`click reload order list button`
    });
  };

  renderTip = () => {

    const NO_DATA_CONFIG = {
      1:{
        title:intl.get('order.open_no_data.Pending',{
          href:'https://help.dsers.com/order-status-pending/'
        }),
      },
      2:{
        title:intl.get('order.open_no_data.AwaitingOrder',{
          href:'https://help.dsers.com/order-status-awaiting-orders/'
        }),
      },
      3:{
        title:intl.get('order.open_no_data.AwaitingPayment',{
          href:'https://help.dsers.com/order-status-awaiting-payment/'
        }),
      },
      4:{
        title:intl.get('order.open_no_data.AwaitingShipment',{
          href:'https://help.dsers.com/order-status-awaiting-shipment/'
        }),
      },
      9:{
        title:intl.get('order.open_no_data.AwaitingFulfillment',{
          href:'https://help.dsers.com/order-status-awaiting-fulfillment/'
        }),
      },
      5:{
        title:intl.get('order.open_no_data.Fulfilled',{
          href:'https://help.dsers.com/order-status-fulfilled/'
        }),
      },
      6:{
        title:intl.get('order.open_no_data.Canceled',{
          href:'https://help.dsers.com/order-status-canceled/'
        }),
      },
      7:{
        title:intl.get('order.open_no_data.FailedOrder',{
          href:'https://help.dsers.com/order-status-failed-orders/'
        }),
      },
    }

    if(!this.state.orderList.length){
      return null
    }

    return <>
      <div className="bottomLine">
        <p dangerouslySetInnerHTML={{__html:NO_DATA_CONFIG[this.status]?.title}}></p>
      </div>
    </>
  }

  // 展示fackbook聊天窗
  showFBDialog = e => {
    e.stopPropagation();
    if (window.FB) {
      FB.CustomerChat.showDialog();
    }
  };

  // 回到顶部
  backTop = () => {
    const c = document.getElementById('orderBox');
    c.scrollIntoView({
      block: 'start',
      behavior: 'smooth'
    });
  };

  // 回到底部
  backBottom = () => {
    const c = document.getElementById('orderBox');
    c.scrollIntoView({
      block: 'end',
      behavior: 'smooth'
    });
  };

  changeSearchType = v => {
    this.searchType = v;

    this.setState({
      searchInputType:v
    })

    reactGaEvent({
      category: 'Order',
      action: 'filterSearch',
      label: `${v}`
    });
  };

  searchMoreFilter = () => {
    return (
      <Select
        placeholder="Filter"
        dropdownMatchSelectWidth={false}
        style={{ width: 104 }}
        onChange={this.changeSearchType}
        getPopupContainer={triggerNode => triggerNode.parentNode}
        defaultValue={this.state.searchInputType}
        suffixIcon={
          <img
            className="select_icon"
            src={require('../../assets/newImportList/icon_expand_more-24px.png')}
          />
        }
      >
        <Option value={1}>{intl.get('order.search_type.order_no')} </Option>
        <Option value={2}>{intl.get('order.search_type.note')}</Option>
        <Option value={3}>{intl.get('order.search_type.tm_order_no')}</Option>
        <Option value={4}>{intl.get('order.search_type.product')}</Option>
        <Option value={5}>{intl.get('order.search_type.email')}</Option>
        <Option value={6}>{intl.get('order.search_type.customer_name')}</Option>
        <Option value={7}>{intl.get('order.search_type.tracking_no')}</Option>
      </Select>
    );
  };

  // 显示批量fulfilled提示
  showFulfillOrdersManuallyTip = e => {
    clearTimeout(this.fulfillTipTimer);
    this.fulfillTipTimer = setTimeout(() => {
      this.setState({
        visibleFulfillOrdersManuallyTip: true
      });
    }, 100);
  };

  // 隐藏批量fulfilled提示
  hideFulfillOrdersManuallyTip = e => {
    clearTimeout(this.fulfillTipTimer);
    this.fulfillTipTimer = setTimeout(() => {
      this.setState({
        visibleFulfillOrdersManuallyTip: false
      });
    }, 100);
  };

  fulfillTipTimer = null;

  // 更新ext数据
  updataExt = options => {
    this.changeOid = options.oid; // 改变的订单id

    switch (options.type) {
      case 'note':
        this.updataExtNote(options);
        break;
      case 'address':
        this.updataExtAddress(options);
        break;
      case 'bind':
        this.updataExtBind(options);
        break;
      case 'fright':
        this.updatafreight(options);
        break;
      case 'orderNo':
        this.updataNo(options);
        break;
      case 'trackNo':
        this.updataNo(options);
        break;
      case 'msg':
        this.updataMsg(options);
        break;
      case 'trackNoSave':
        this.trackNoSave(options);
        break;
    }
  };

  trackNoSave = (options) => {
    console.log('我执行了', options)
    setTimeout(()=>{
      this.onlySaveOrder(options.oid, false,true,'')
    },700)
  }

  // 更新子订单留言
  updataMsg = options => {
    const { index, oid, v } = options; // index 子订单索引

    const {
      ext: { lineitems }
    } = this.listMap[oid];

    const sonIndex = this.getSonIndex(lineitems[index], options.sonIndex); // 子子订单的索引(lineitems里sp数组的索引)

    lineitems[index].sp[sonIndex || 0].msg = v;

    this.hasChange(oid);
  };

  cacheNo = {}; // 缓存用户添加的 订单号 物流单号

  // 子子订单的索引(lineitems里sp数组的索引)
  getSonIndex = (lineitem, sonIndex, useSp) => {
    if (sonIndex || sonIndex === 0) {
      return sonIndex;
    }
    
    const { status } = this.state;
    let ii = 0;

    if (lineitem.sp.length == 1) {
      return ii;
    }

    let flag = false;

    // base mapping 主副供应商用哪个
    if (lineitem.sp.length == 2 && lineitem.supplier_map_type == 1) {
      lineitem.sp.forEach((item, i) => {
        // awaiting shipment(4) > awaiting payment(4) > failed order(7)  匹配顺序
        if ([4, 3].includes(item.status)) {
          ii = i;
          flag = true;
        }
        if (item.status == status && item.is_default && !flag) {
          ii = i;
          flag = true;
        }
        if (item.status == status && !item.is_default && !flag) {
          ii = i;
        }
      });
      if(lineitem.sp.every((item=>item.status == 7))){
          let orderIndex = lineitem.sp.findIndex(item=> !item.is_default);
          if(orderIndex > -1){
            ii  = orderIndex
          }
        
    }
    }
    if(lineitem.sp.length == 2 && lineitem.supplier_map_type == 3){
      lineitem.sp.forEach((item,index) => {
        if(item?.platform_product_id == useSp?.platform_product_id){
          ii = index
        }
      })
    }
    console.log('更新的值', lineitem, ii)
    return ii;
  };

  // 更新物流单号和订单号
  updataNo = options => {
    const { index, oid, v, type, trackNoByAE } = options;

    const {
      ext: { lineitems }
    } = this.listMap[oid];

    const sonIndex = this.getSonIndex(lineitems[index], options.sonIndex); // 子子订单的索引(lineitems里sp数组的索引)

    const sp = lineitems[index].sp[sonIndex || 0];

    const obj = { lineitem_id: lineitems[index].lineitem_id };

    console.log('type', type, sp)

    // 更新物流
    if (type == 'trackNo') {
      obj.track_no = v;

      sp.logistics_infos = sp.logistics_infos || [];
        v.forEach((no, i) => {
          if (sp.logistics_infos[i]) {
            sp.logistics_infos[i].logistics_no = `${v[i]}`;
            sp.logistics_infos[i].logistics_service =
              sp.logistics_company || trackNoByAE[i].logistics_service || '';
          } else {
            sp.logistics_infos.push({
              logistics_no: `${v[i]}`,
              logistics_service:
                sp.logistics_company || trackNoByAE[i].logistics_service || ''
            });
          }
        });

    } else {
      // 更新订单号
      sp.platform_order_id = v;
      obj.ali_order_id = v;
    }

    const cacheKey = `${oid}_${lineitems[index].lineitem_id}_${sonIndex || 0}`;
    if (this.cacheNo[cacheKey]) {
      Object.assign(this.cacheNo[cacheKey], obj); // 之前存过更新
    } else {
      this.cacheNo[cacheKey] = obj; // 没存就添加
    }

    this.hasChange(oid);
  };

  // 更新物流
  updatafreight = options => {
    const { index, company, oid, useSp } = options;
    console.log('更新的值为', options)
    const {
      ext: { lineitems }
    } = this.listMap[oid];

    const sonIndex = this.getSonIndex(lineitems[index], options.sonIndex, useSp); // 子子订单的索引(lineitems里sp数组的索引)
    console.log('更新是sonIndex', sonIndex)
    const {
      freightAmount = company.standardFreightAmount,
      serviceName
    } = company;

    const sp = lineitems[index].sp[sonIndex || 0];
    console.log('更新的sp为', sp)

    sp.freight_cost = `${freightAmount.value || 0}`; // 物流成本
    sp.logistics_company = serviceName; // 用户选的物流

    this.hasChange(oid);
  };

  // 更新note 用户自己看的备注
  updataExtNote = options => {
    this.listMap[options.oid].ext.note = options.value;
    // this.hasChange(options.oid);
  };

  cacheAddress = {}; // 改变的address根据订单id缓存 取消时作废 保存时替换用

  // 缓存address
  updataExtAddress = options => {
    const { oid, address, prevCountryCode } = options;

    this.cacheAddress[oid] = address;

    // if (this.state.status == 7 && options.isAllRight) {
    //   const { ext, ext: { err = {} } } = this.listMap[oid];
    //   if (err.code == 6) {
    //     //delete ext.err;
    //   }
    // }
    this.changeCountry(oid, prevCountryCode); // 改国家
    this.hasChange(oid);
  };

  // 更改国家从新获取物流
  changeCountry = (oid, prevCountryCode) => {
    const {
      childrens,
      ext: { address },
      isShopifyDelete
    } = this.listMap[oid];

    const cacheCountryCode = this.cacheAddress[oid].country_code;

    const replaceStatus = [2, 7]; // awaitging order 和 failed order
    const updataSp = [];

    if (prevCountryCode === cacheCountryCode || !prevCountryCode) {
      return;
    }

    // shopify 删除
    if (isShopifyDelete) {
      return;
    }

    childrens.forEach((child, ci) => {
      // 商品加黑
      if (child.is_black_list == 2) {
        return;
      }
      if (child.platform_type != 4) {
        return;
      }
      child.sp.forEach((sp, si) => {
        if (replaceStatus.includes(sp.status) && sp.platform_product_id) {
          // 需要更新物流的订单列表
          updataSp.push({
            prod_id: sp.platform_product_id,
            sku: sp.platform_sku,
            sku_id:sp?.platform_sku_id,
            country_code: cacheCountryCode,
            quantity: sp.quantity,
            index: [oid, ci, si],
            province: address.province || '',
            city: address.city || ''
          });
        }
      });
    });

    if (updataSp.length) {
      this.getFreight(updataSp, 0);
    }
  };

  // 获取物流
  getFreight = (updataSp, index, flag) => {
    if (flag) {
      console.log('执行了');
      return;
    }
    const spIndex = updataSp[index].index;

    delete updataSp[index].index;

    updataSp[index].quantity = updataSp[index].quantity
      ? updataSp[index].quantity
      : 1;
      console.log("aaaaaaaa",updataSp)
    this.props.dispatch({
      type: 'order/freight',
      payload: {
        data:{...updataSp[index],supplier_type:4},
        callback: d => {
          if (d.code == 2000) {
            this.updataSpFreight(d.data.freight, spIndex);
          }
          if (index < updataSp.length - 1) {
            this.getFreight(updataSp, index + 1);
          } else {
            this.forceRender();
          }
        }
      }
    });
  };

  // 强制刷新
  forceRender = () => {
    const { orderList } = this.state;
    let list = cloneDeep(orderList);

    this.setState({
      orderList: list
    });
    list = null;
  };

  // 更改国家后更新sp物流
  updataSpFreight = (freight, spIndex) => {
    const {
      ext: { lineitems }
    } = this.listMap[spIndex[0]];

    lineitems.forEach((lineItem, li) => {
      if (li != spIndex[1]) {
        return;
      }
      lineItem.sp.forEach((sp, si) => {
        if (si != spIndex[2]) {
          return;
        }
        sp.freights = freight;
        sp.logistics_company =  sp.freights?.[0]?.serviceName; // 让用户从新选物流
        sp.freight_cost = '0';
      });
    });
  };

  changeOid = '';

  hasChangeTimer = null;

  // 订单是否更改过
  hasChange = () => {
    clearTimeout(this.hasChangeTimer);
    this.hasChangeTimer = setTimeout(this.hasChangeDebounce, 500);
  };

  hasChangeDebounce = () => {
    const oid = this.changeOid;
    if(!window?.SYNC_SHOW_BTN){
      this.listMap[oid].showSave = true; // 显示保存取消按钮
    }
    this.renderOrderList(); // setState 更新列表
    window.SYNC_SHOW_BTN = false;
  };

  cacheBind = {}; // 换绑根据订单id缓存 取消时作废 保存时替换用

  idEditSave = false;
  bindEdit = {};
  bindEditPlatFormTypeData = []
  // 缓存换绑数据
  updataExtBind = options => {
    console.log('options', options);
    const { oid, index, bind } = options;

    this.bindEdit = bind;

    const {
      ext: { lineitems },
      childrens
    } = this.listMap[oid];
    const sonIndex = this.getSonIndex(lineitems[index], options.sonIndex); // 子子订单的索引(lineitems里sp数组的索引)

    this.idEditSave = options.isEditSave || false;

    if (!this.cacheBind[oid]) {
      this.cacheBind[oid] = {};
    }

    this.cacheBind[oid][`${index}-${sonIndex}`] = options.bind; // [oid][`${index}-${sonIndex}`] 哪个订单 哪个子订单 哪个子子订单换绑了

    this.hasChange(oid);
    if(options?.bind?.hasOwnProperty('supply_type') && window.TMALL_USER){
      if(lineitems[index].platform_type !== options?.bind?.supply_type){
        lineitems[index].supply_platform = options?.bind?.supply_type

        this.bindEditPlatFormTypeData.push({
          lineitem_id:lineitems[index].lineitem_id,
          platform_type:options?.bind?.supply_type
        })
        const cSp = childrens[index].sp[sonIndex]
        Object.assign(cSp,{
          actionEditChangeProduct: options?.bind?.supply_type
        })
      }else{
        this.bindEditPlatFormTypeData.push({
          lineitem_id:lineitems[index].lineitem_id,
          platform_type:options?.bind?.supply_type
        })
        const cSp = childrens[index].sp[sonIndex]
        Object.assign(cSp,{
          actionEditChangeProduct:false
        })
      }
    }
  };

  // 是否展示edit
  toggleBind = (oid, childIndex) => {
    const arr = this.listMap[oid].childrens[childIndex].showBind;
    arr[childIndex] = !arr[childIndex];
    this.renderOrderList();
  };
  // 取消保存
  cancelOrder = (oid, boolean) => {
    const {
      ext,
      ext: { lineitems }
    } = this.listMap[oid];
    const originExt = this.originListMap[oid].ext;

    delete this.cacheAddress[oid];
    delete this.cacheBind[oid];
    ext.note = originExt.note;
    ext.address = { ...originExt.address };

    lineitems.forEach((item, i) => {
      item.sp.forEach((sp, si) => {
        if (item.supplier_map_type == 1 && sp.is_default == false) {
          return;
        }

        sp.logistics_company = originExt.lineitems[i].sp[si].logistics_company;
        sp.platform_order_id = originExt.lineitems[i].sp[si].platform_order_id;
        sp.logistics_infos = cloneDeep(
          originExt.lineitems[i].sp[si].logistics_infos
        );
        sp.msg = originExt.lineitems[i].sp[si].msg;
      });
    });

    this.listMap[oid].showSave = false;

    // this.renderOrderList();

    this.getOrderList();
  };

  // 重新渲染列表
  renderOrderList = () => {
    const { orderList } = this.state;

    this.setState({
      orderList: [...orderList]
    });
  };

  onlySaveOneOrderHasFreight = true; // 换绑时 仅 保存或下单 一个订单 有没有选物流

  getPayPalState = async () => {
    try {
      const res = await Get('/auth/paypal/has_permissions_error');
      if (res.code === 2000 && res.data) {
        const lastShowTime = localStorage.getItem('lastShow');
        if (lastShowTime) {
          const currentTime = Date.now();
          this.timeGap = (currentTime - lastShowTime) / 86400000;
        }
        if (this.timeGap == -1) {
          this.setState({
            showPayPalModal: res.data.has
          });
        } else if (this.timeGap > 1) {
          this.setState({
            showPayPalModal: res.data.has
          });
        }
      }
    } catch (error) {
      console.log('paypalPremissionsError', error);
    }
  };

  // 保存一个订单 (用户有更改 没点保存 点下单也要先保存在下单)
  onlySaveOrder = (oid, asyncState, isLegel, sku, productId, lineItemId, record = {}) => {
    console.log('record ext',record.ext)
    this.onlySaveOneOrderHasFreight = true; // 换绑时 仅 保存或下单 一个订单 有没有选物流
    this.saveOrderList = [];
    this.saveOrderList.push(this.saveOrder(oid));
    // 换绑没选物流不能保存
    if (!this.onlySaveOneOrderHasFreight) {
      message.error(intl.get('order.select_shipping_method_tip'));
      return;
    }
    this.submitSaveOver(1,undefined, asyncState,isLegel,sku, productId, lineItemId,record?.ext);  
  };

  // 获取保存数据
  saveOrder = oid => {
    const {
      ext: { address = {}, lineitems, transactions, fulfillments },
      childrens,
      detail,
      storeId
    } = this.listMap[oid];
    const cacheAddress = this.cacheAddress[oid]; // 之前编辑过的address
    const originExt = this.originListMap[oid]?.ext; // 最开始的订单数据

    if (cacheAddress) {
      Object.assign(address, cacheAddress); // 合并编辑的address
    }

    lineitems.forEach((item, i) => {
      if (!item.sp) {
        return;
      }
      const spByUpdatedAliNo = [];
      item.sp.forEach((sp, si) => {
        const spBind = this.cacheBind[oid] && this.cacheBind[oid][`${i}-${si}`];
        const cSp = childrens[i].sp[si];
        if (!cSp.platform_type) {
          cSp.platform_type = 4
        }
        if (spBind && spBind.logistics_company) {
          item.platform_type = spBind.supply_type;
          childrens[i].platform_type = spBind.supply_type;
          Object.assign(sp, spBind); // 合并换绑的数据 保存用
          Object.assign(cSp, spBind); // 合并换绑的数据 展示用
        }
        if (spBind && !spBind.logistics_company) {
          this.onlySaveOneOrderHasFreight = false; // 手动换绑 没选物流
        }
        
        if (cSp.platform_type != 4 && spBind && spBind.logistics_company) {
          Object.assign(cSp, { editChangePlatform: true })
      }

        if (sp.platform_order_id == '') {
          // 订单本来有订单号，用户删除或者编辑订单号出错 把原来的添加回去
          sp.platform_order_id =
            originExt.lineitems[i].sp[si].platform_order_id || '';
          sp.logistics_infos = originExt.lineitems[i].sp[si].logistics_infos;
        }

        const cacheKey = `${oid}_${item.lineitem_id}_${si}`;
        // 是这次编辑的
        // 并且ali_order_id合法
        // 并且与原来的order_id不一致 则需要重新更改sp状态
        if (
          this.cacheNo[cacheKey] &&
          this.cacheNo[cacheKey].ali_order_id &&
          this.cacheNo[cacheKey].ali_order_id !==
            originExt.lineitems[i].sp[si].platform_order_id
        ) {
          if (sp.platform_order_id && [1, 2, 6, 7].includes(sp.status)) {
            sp.status = 3; // 添加订单号相当于已下单 状态改成 awaiting payment 3
          }
          if (
            sp.logistics_infos &&
            sp.logistics_infos.length &&
            [1, 2, 3, 6, 7].includes(sp.status)
          ) {
            spByUpdatedAliNo.push(si);
            sp.status = 4; // 添加运单号相当于已发货 状态改成 awaiting shipment 4
          }
        }
      });

      // 计算 lineitem 的status
      if (item.status !== 8192) {
        item.status = this.getLineItemsStatus(
          childrens[i],
          item,
          detail,
          transactions,
          fulfillments
        );
      }
      // 如果更新了物流单号和订单号，sp.status 需要更改。因为在内部改会影响 item.status 的计算，所以放在 item.status 更新之后操作
      item.sp.forEach((s, index) => {
        if (spByUpdatedAliNo.includes(index)) {
          // eslint-disable-next-line
          s.status = 5;
        }
      });
    });

    let aliexpress_orders = [];
    if (this.getCacheNo(oid).length) {
      aliexpress_orders = this.getCacheNo(oid);
    }

    const obj = {
      order_id: oid,
      ext: this.listMap[oid].ext,
      aliexpress_orders,
      store_id: storeId
    };

    obj.ext = filterUpdateExtLineItems(4, obj.ext, this.originalOldOrderMap[oid].ext)

    //过滤空的物流
    if (transactions && Array.isArray(transactions)) {
      transactions.forEach(transactionsItem => {
        if (transactionsItem.hasOwnProperty('order_info')) {
          Object.keys(transactionsItem.order_info).forEach(
            (orderInfoItem, index) => {
              let obj = transactionsItem['order_info'][orderInfoItem];
              if (obj?.order_status == '' && obj?.logistics_status == '') {
                delete transactionsItem.order_info[orderInfoItem];
              }
              if (!Object.keys(obj).length) {
                delete transactionsItem.order_info[orderInfoItem];
              }
            }
          );
        }
      });
    }

    return obj;
  };

  // 有没有需要保存的ae订单号物流
  getCacheNo = oid => {
    const arr = [];
    const arrSplitTrackNo = [];
    Object.entries(this.cacheNo).forEach(item => {
      if (item[0].includes(oid)) {
        arr.push(item[1]);
      }
    });

    if (arr.length) {
      arr.forEach(item => {
        if (item.track_no && item.track_no.length) {
          item.track_no.forEach(no => {
            arrSplitTrackNo.push({
              lineitem_id: item.lineitem_id,
              ali_order_id: Number(item.ali_order_id),
              track_no: `${no}`
            });
          });
        } else {
          arrSplitTrackNo.push({
            lineitem_id: item.lineitem_id,
            ali_order_id: Number(item.ali_order_id),
            track_no: ''
          });
        }
      });
    }
    return arrSplitTrackNo;
  };

  // basMap 到底用哪个sp
  getWhichSpCanFulfilled = child => {
    const { sp = [] } = child;
    const { status } = this.state;
    let index = 0;
    let flag = false;

    if (sp.length === 2) {
      sp.forEach((oneSp, si) => {
        // 4 > 3 > 7 订单状态 有awaiting shipment就优先使用
        if ([4, 3, 7].includes(oneSp.status)) {
          index = si;
          flag = true;
        }
        if (oneSp.is_default && oneSp.status == status && !flag) {
          index = si;
          flag = true;
        }
        if (oneSp.status == status && !oneSp.is_default && !flag) {
          index = si;
        }
        if (!oneSp.is_default && oneSp.platform_order_id) {
          index = si;
          flag = true;
        }
      });
    }

    return index;
  };

  // sp状态对应的lineitem的状态
  statusMap = {
    '1': 1,
    '2': 2,
    '3': 4,
    '4': 8,
    '5': 2048,
    '6': 16,
    '7': 32
  };

  // 求 ext 中 lineitems的状态
  getLineItemsStatus = (
    child,
    lineitem,
    detail,
    transactions = [],
    extFulfillments = []
  ) => {
    // lineitem是ext->lineitems中的第i个
    const { status } = this.state;
    const { refunds, fulfillments, line_items } = detail;
    const fulfillableQuantity = line_items.find(
      item => item.id === lineitem.lineitem_id
    ).fulfillable_quantity;

    const arr = [];

    if (refunds) {
      refunds.forEach(re => {
        if (re.refund_line_items) {
          re.refund_line_items.forEach(item => {
            if (item.line_item_id == lineitem.lineitem_id && !arr.includes(6)) {
              arr.push(6);
            }
          });
        }
      });
    }

    let lineItemFulfilled = extFulfillments.includes(lineitem.lineitem_id);

    if (fulfillments) {
      fulfillments.forEach(fu => {
        if (fu.status === 'success') {
          fu.line_items.forEach(item => {
            if (item.id == lineitem.lineitem_id && !arr.includes(5)) {
              arr.push(5);
              lineItemFulfilled = true;
            }
          });
        }
      });
    }

    if (child.supplierMapType == 1) {
      if (lineitem.sp) {
        arr.push(lineitem.sp[this.getWhichSpCanFulfilled(lineitem)].status);
      }
    } else if (lineitem.sp) {
      lineitem.sp.forEach(item => {
        arr.push(item.status);
      });
    }
    // 没有fulfill sp状态却是5 判断为awaiting fulfillment
    if (!lineItemFulfilled) {
      const fulfilledIndex = arr.indexOf(5);
      if (fulfilledIndex > -1) {
        arr[fulfilledIndex] = 4;
      }
    }

    lineitem.sp.forEach(sp => {
      const aeStatusArr = [];
      transactions.forEach(tr => {
        const {
          order_info: {
            [sp.platform_order_id || 123]: { order_status } = {}
          } = {}
        } = tr;
        if (order_status) {
          aeStatusArr.push(order_status);
        }
      });

      if (
        aeStatusArr[aeStatusArr.length - 1] === 'PLACE_ORDER_SUCCESS' &&
        !arr.includes(3) &&
        fulfillableQuantity
      ) {
        arr.push(3);
      }
    });

    const hasFailedStatus = lineitem.status & 32;
    const hasAwaitingOrderStatus = lineitem.status & 2;

    if (hasFailedStatus === 32 && fulfillableQuantity && status != 7) {
      arr.push(7);
    }

    if (hasAwaitingOrderStatus === 2 && fulfillableQuantity && status != 2) {
      arr.push(2);
    }
    console.log('arr为', arr);
    let v = 0;
    arr.forEach(n => {
      v |= this.statusMap[n];
    });

    const hasAwaitingStatus = lineitem.status & 2; // 之前是不是有2这个状态
    const hasPaymentStatus = v & 4; // 新状态是不是有3这个状态
    const hasShipmentStatus = v & 8; // 新状态是不是有4这个状态

    if (
      hasAwaitingStatus === 2 &&
      hasPaymentStatus !== 4 &&
      hasShipmentStatus !== 8 &&
      fulfillableQuantity
    ) {
      v |= 2;
    }

    return v;
  };

  // 保存 ext 时成功后,  ext 里的 updated_at 时间戳 要用后台返回的新的  保存直接下单才用替换， 只保存会重新获取
  extUpdatedAt = {};

  cacheExtUpdatedAt = (oid, updated_at) => {
    this.extUpdatedAt[oid] = updated_at * 1;
  };

  // 提交修改订单的数据
  submitSaveOver = (
    type,
    i,
    asyncState,
    isLegel,
    sku,
    productId,
    lineItemId,
    recordExt
  ) => {
    // type 保存完 1更新列表  2保存再下单
    //  asyncState 是否刚同步完order NO
    // isLegel 更改的订单号是否合法
    i = i || 0;
    const accountId = localStorage.getItem('aliAccountId');
    // console.log('asyncState--------', asyncState);
    // console.log('isLegel------------', isLegel);
    if (asyncState && isLegel) {
      this.saveOrderList[i].ext.lineitems.forEach(item => {
        if (item.lineitem_id == lineItemId) {
          item?.sp.forEach(q => {
            if (q.platform_sku == sku && q.platform_product_id == productId) {
              q.account_id = accountId;
            }
          });
        }
      });
    }

    if(this.saveOrderList[i]?.order_id){
      this.listMap[this.saveOrderList[i]?.order_id].showSave = false;
    }

    console.log('this.listMap', this.listMap , this.saveOrderList)

    this.saveOrderList[i]?.ext?.transactions?.forEach(transactionItem => {
      if (transactionItem?.hasOwnProperty('order_info')) {
        let orderInfo = transactionItem?.order_info;
        Object.keys(orderInfo)?.forEach(orderInfoKey => {
          if (!Object.keys(orderInfo[orderInfoKey])?.length) {
            delete orderInfo[orderInfoKey];
          }
        });
      }
    });

    if(this.bindEditPlatFormTypeData.length){
      //强制去改数据
      this.saveOrderList[i]?.ext?.lineitems.forEach(lineItem => {
        this.bindEditPlatFormTypeData.forEach(dataItem => {
          if(lineItem.lineitem_id == dataItem.lineitem_id){
            lineItem.platform_type = dataItem.platform_type
          }
        })
      })
    }

    let saveOrderData = cloneDeep(this.saveOrderList[i]);


    window.UPDATA_EXT = true;
    window.UPDATA_EXT_TIME = +new Date();

    let updateValue = {
      ...saveOrderData,
      type: 'place-order',
      ae_orders: this.props.order.orderNoDetail
    }

    if(recordExt && recordExt.hasOwnProperty('flag')){
      updateValue.ext.flag = recordExt?.flag
    }


    //fulfilled下 sp状态为3的 还是提交3  ---   前提是后台返回3的情况
    if(this.state.status == 5){
      //检测后台数据有没有返回3的情况
      this.state.oldOrderList?.map(oldOrderItem => {
        oldOrderItem?.ext?.lineitems?.map(oldLineItem => {
          if(oldLineItem?.status == 2048){
            oldLineItem?.sp?.map(oldspItem => {
              if(oldspItem?.status == 3 && oldOrderItem?.id == updateValue?.order_id){
                updateValue.ext.lineitems.forEach(lineitemItem => {
                  if(lineitemItem.status == 2048){
                    lineitemItem.sp.forEach(spItem => {
                      if(spItem.status == 5){
                        spItem.status = 3;
                      }
                    })
                  }
                })
              }
            })
          }
        })
      })
      
    }
    this.props.dispatch({
      type: 'order/updataExt',
      payload: {
        data: updateValue,
        callback: d => {
          this.onlySaveOneOrderHasFreight = true;
          if (d.code === 2010) {
            this.cacheAddress = {};
            this.cacheBind = {};
            this.cacheNo = {};

            //成功之后置空
            this.props.dispatch({
              type: 'order/resetNoDetail'
            });

            if (type === 2) {
              this.cacheExtUpdatedAt(this.saveOrderList[i]?.order_id, d.msg);
            }

            // 同时编辑了多个 都要保存
            if (this.saveOrderList.length > i + 1) {
              this.submitSaveOver(type, i + 1);
              return;
            }

            type == 1 && this.getOrderList();
            type == 2 && this.showPlaceOrderComfirm(); // 保存再下单 显示下单弹窗
          }
        }
      }
    });
  };

  // 下单前是否需要保存
  hasChangeBeforeOrder = data => {
    const oid = data.id;
    const {
      ext: { lineitems, note }
    } = data;
    const originExt = this.originListMap[oid] && this.originListMap[oid].ext;
    let flag = false; // 是否有变化

    // 收货地址变化
    if (
      this.cacheAddress[oid] &&
      JSON.stringify(this.cacheAddress[oid]) !=
        JSON.stringify(originExt.address)
    ) {
      flag = true;
    }

    // 有换绑
    const cacheBind = this.cacheBind[oid];
    if (cacheBind) {
      Object.values(cacheBind).forEach(item => {
        if (item) {
          flag = true;
        }
      });
    }

    // note有变化
    if (note != originExt.note) {
      flag = true;
    }

    lineitems.forEach((item, i) => {
      if (!item.sp) {
        return;
      }

      item.sp.forEach((sp, si) => {
        if (item.supplier_map_type == 1 && sp.is_default == false) {
          return;
        }
        if (!originExt.lineitems[i].sp[si]) {
          return;
        }

        // 物流有变化
        if (
          sp.logistics_company !=
          originExt.lineitems[i].sp[si].logistics_company
        ) {
          flag = true;
        }

        // 订单号有变化
        if (
          sp.platform_order_id !=
          originExt.lineitems[i].sp[si].platform_order_id
        ) {
          flag = true;
        }

        // 物流单号有变化
        if (
          JSON.stringify(sp.logistics_infos) !=
          JSON.stringify(originExt.lineitems[i].sp[si].logistics_infos)
        ) {
          flag = true;
        }
      });
    });

    return flag;
  };

  placeOrderData = []; // 去下单数据

  saveOrderList = []; // 需要保存订单的数据

  hasSave = false; // 关闭下单确认框时 有保存过就从新获取列表

  paymentOrderData = [] // 需支付的数据

  placeOrder = oid => {
    console.log('下单点击', this.placeOrderData);
    if(this.status == 2){
      CommonDataCollect({
                   action: 'tm_order_click',
                   event_type:'tm_order'
                 });  
   }
    const {
      userInfo: { user_id }
    } = this.props;
    CommonDataCollect({
      user_id: user_id,
      event_type: 'subscription_analysis',
      action: 'place_an_order',
      trans_to: 'place_an_order_one'
    });

    if (this.checkIsNewUserWithoutAe()) {
      this.showNewUserAeModal();
      return;
    }
    this.orderDistribute(oid)
    };

    onePayment = (oid) => {
      const data = this.listMap[oid];
      this.paymentOrderData = [data]
      this.setState({
        showPaymentOrder:true
      })
    }

  handleOrderConfirmClose = () => {
    // this.setState({ placeOrderType: undefined });
  };

  purchaseMultiple = () => {
    const {
      userInfo: { user_id }
    } = this.props;
    CommonDataCollect({
      user_id: user_id,
      event_type: 'subscription_analysis',
      action: 'place_an_order',
      trans_to: 'place_an_order_all'
    });
    if(this.status == 2){
      CommonDataCollect({
        action: 'tm_order_check',
        event_type:'tm_order'
      });  
     }
    // blerlo  未绑定AE用户 --批量下单 （已经有逻辑不重复展示）
    if (!window.IS_BIND_AE) {
      window.EVENT.emit(
        GuildeAction.OblerloGuide_Pop,
        `AE-${Date.now()}`,
        true
      );
      return;
    }
    if (this.checkIsNewUserWithoutAe()) {
      this.showNewUserAeModal();
      return;
    }
      this.batchOrderDistribute();
  };

  // 批量下单
  batchOrderDistribute = () => {
    const { selectedRows } = this.state; // 选中的订单
    let flag2 = false;

    this.onlySaveOneOrderHasFreight = true; // 手动换绑是否选物流 没选不让下单

    this.placeOrderData = [];
    this.saveOrderList = [];

    selectedRows.forEach(item => {
      const flag = this.hasChangeBeforeOrder(item); // 下单前是否需要保存
      if (flag) {
        flag2 = true;
        this.saveOrderList.push(this.saveOrder(item.id));
      }
    });

    // 需要保存先保存
    if (flag2) {
      this.hasSave = true;
      this.placeOrderData = selectedRows;
      this.submitSaveOver(2); // 2 保存完下单
      return;
    }

    // 不需要保存
    this.placeOrderData = selectedRows;
    // this.setState({ placeOrderType: 'batch' });
    this.showPlaceOrderComfirm(); // 展示下单弹窗
  };

  // 单个下单
  orderDistribute = oid => {
    this.onlySaveOneOrderHasFreight = true; // 手动换绑是否选物流 没选不让下单

    const data = this.listMap[oid];
    const flag = this.hasChangeBeforeOrder(data); // 下单前有没有编辑 单个下单只判断当前订单有没有编辑

    this.placeOrderData = [];
    this.saveOrderList = []; // 保存会用到

    // 需要保存
    if (flag) {
      this.hasSave = true;
      this.saveOrderList.push(this.saveOrder(oid)); // 需要保存的订单列表
      // 手动换绑是否选物流 没选不让下单
      if (!this.onlySaveOneOrderHasFreight) {
        message.error('Please select a shipping method.');
        return;
      }
      this.placeOrderData.push(this.listMap[oid]); // 下单数据
      this.submitSaveOver(2); // 2 保存完下单
      return;
    }

    // 不需要保存
    this.placeOrderData.push(this.listMap[oid]); // 下单数据
    // this.setState({ placeOrderType: 'single' });
    this.showPlaceOrderComfirm();
  };

  // 显示下单确认弹窗
  showPlaceOrderComfirm = () => {
    const { status } = this.state;
    const mayBeFakeFailedArr =
      status === 7 &&
      this.placeOrderData
        .filter(item => {
          const err = item?.ext?.multiple_platform_error?.tmall || {};
          const { code, msg } = err;
          return (
            (code === 15 && msg === 'Remote service error') ||
            (code === 9 &&
              msg ===
                'code: REMOTE_CREATE_ORDER_RESULT_ERROR,msg: create order error')
          );
        })
        ?.map(item => item?.detail?.name);
    // console.log(mayBeFakeFailedArr)
    if (mayBeFakeFailedArr && mayBeFakeFailedArr.length) {
      const title = (
        <div>
          {intl.get('order.may_be_fake_failed_order1')}
          {mayBeFakeFailedArr.map((item, index) => {
            return (
              <React.Fragment key={item}>
                {index !== 0 ? ',' : null}
                &nbsp;<span className={styles.errNo}>{item}</span>&nbsp;
              </React.Fragment>
            );
          })}
          {intl.get('order.may_be_fake_failed_order2')}
        </div>
      );
      Modal.confirm({
        title,
        className: styles.modalWithErrorIcon,
        okText: intl.get('order.go_ae_check_order'),
        okType: 'primary',
        cancelText: intl.get('public.dismiss'),
        icon: 'info-circle',
        onOk: () => {
          window.open('https://trade.aliexpress.com/orderList.htm', 'blank');
        },
        onCancel: () => {
          this.showOrderConfirmAfterCheck();
        }
      });
      return;
    }
    this.showOrderConfirmAfterCheck();
  };

  showOrderConfirmAfterCheck = () => {
    this.onlySaveOneOrderHasFreight = true;

    this.placeOrderData.forEach(item => {
      const updated_at = this.extUpdatedAt[item.id];
      if (updated_at) {
        item.ext.updated_at = updated_at;
      }
    });
    this.extUpdatedAt = {};

    this.setState({
      showPlaceOrder: true
    });
  };

  // 隐藏下单确认弹窗
  hidePlaceOrder = (hasSubmitOrder,tmallOrderResult) => {
    const { tutorialType } = this.props;
    this.placeOrderData = [];
    // 有下单 或有保存 更新订单列表
    if (hasSubmitOrder || this.hasSave) {
      dispatchEventForGuide({
        type: 'order',
        payload: { category: 'PLACE_ORDER_OK' }
      });
      if (tutorialType === 0) {
        setTimeout(() => {
          dispatchEventForGuide({
            type: 'order',
            payload: {
              category: 'PLACE_ORDER_STATUS_UPDATED',
              status: 'success'
            }
          });
        }, 1000);
      }

      this.setState({
        selectedRows: [],
        showPlaceOrder: false
      });
      this.getOrderList();
      this.queryOrderResult(tmallOrderResult);
    } else {
      // 只隐藏下单弹窗
      this.setState({
        showPlaceOrder: false
      });
    }
    this.hasSave = false;
  };

  //关闭支付弹窗
  hidePaymentOrder = (type) => {
    this.setState({
      showPaymentOrder:false
    })
    if(type === 'clickPayment'){
      window.EVENT.emit(OrderAction.TMALL_PROCESS_START, true)
      this.getOrderList()
    }
  }

  queryOrderResultTimer = null;

  orderTimeStamp = 0;

  // 查询下单结果
  queryOrderResult = (orderResult) => {
    if (orderResult) {
      this.setState({
        awaitingOrderNumber: 0,
        succeedOrderNumber: orderResult.success,
        failedOrderNumber: orderResult.failed,
        showOrderResult: true
      });
    }
  };

  // 获取下单结果
  getOrderTask = () => {
    this.props.dispatch({
      type: 'topBtn/task',
      payload: {
        data: {
          start_at: this.orderTimeStamp - 60
        },
        callback: d => {
          const { tutorialType } = this.props;
          if (d.code === 2000 || d.code === 2010) {
            let n = 0;
            let n1 = 0;
            let n2 = 0;
            if (d.data) {
              d.data.forEach(item => {
                if ([0, 1, 2, 6].includes(item.status)) {
                  n += item.order_count;
                }

                if ([3, 4, 5, 7].includes(item.status)) {
                  n2 += item.order_count;
                }

                if (item.status === 8) {
                  n1 += item.order_count;
                }
              });
            }

            if (window.DS_BEGINNER_GUIDE_ACTIVE && tutorialType === 0) {
              n1 = 1;
            }

            this.setState({
              awaitingOrderNumber: n, // 待下单数量
              succeedOrderNumber: n1, // 成功数量
              failedOrderNumber: n2, // 失败数量
              showOrderResult: true
            });
            if (tutorialType === 1) {
              if (n1 > 0) {
                dispatchEventForGuide({
                  type: 'order',
                  payload: {
                    category: 'PLACE_ORDER_STATUS_UPDATED',
                    status: 'success'
                  }
                });
              }
              if (n2 > 0) {
                dispatchEventForGuide({
                  type: 'order',
                  payload: {
                    category: 'PLACE_ORDER_STATUS_UPDATED',
                    status: 'fail'
                  }
                });
              }
            }

            localStorage.setItem('orderResult', JSON.stringify([n, n1, n2]));

            // 没有待下单数量
            if (n === 0) {
              if (n1 > 0 && n2 === 0 && n === 0) {
                this.setState({
                  showReviewBanner: true
                });
              }
              clearInterval(this.queryOrderResultTimer);
              localStorage.removeItem('orderTimeStamp');
              this.getOrderList();
            }
            // 是否至少一单下单成功
            const isSuccss = d.data?.some(i => {
              return i.status == 8;
            });
            if (isSuccss && this.props.noviceGuidanceInfo.placed == 0) {
              sendNoviceGuidanceInfo({ placed: 1 }, () => {
                this.props.dispatch({ type: 'user/getNoviceGuidance' });
              });
            }
          }
        }
      }
    });
  };

  // 获取下单结果 老接口
  getOldOrderTask = () => {
    this.props.dispatch({
      type: 'topBtn/taskOld',
      payload: {
        data: {
          start_at: this.orderTimeStamp - 60
        },
        callback: d => {
          if (d.code === 2000 || d.code === 2010) {
            let n = 0;
            let n1 = 0;
            let n2 = 0;
            if (d.data) {
              d.data.forEach(item => {
                if (item.status < 2) {
                  n += item.order_count;
                }
                if (item.status == 2) {
                  n1 += item.order_count;
                }
                if (item.status == 3) {
                  n2 += item.order_count;
                }
              });
            }

            this.setState({
              awaitingOrderNumber: n,
              succeedOrderNumber: n1,
              failedOrderNumber: n2,
              showOrderResult: true
            });

            localStorage.setItem('orderResult', JSON.stringify([n, n1, n2]));

            if (n === 0) {
              if (n1 > 0 && n2 === 0 && n === 0) {
                this.setState({
                  showReviewBanner: true
                });
              }
              clearInterval(this.queryOrderResultTimer);
              localStorage.removeItem('orderTimeStamp');
              this.getOrderList();
            }
          }
        }
      }
    });
  };

  // 隐藏下单结果
  hideOrderResult = () => {
    localStorage.removeItem('orderResult');
    this.setState({
      showOrderResult: false
    });
  };

  // 一条大订单是否可以下单
  oneOrderIsDisabled = (oneOrder, status) => {
    let flag = true; // 为true不能下单
    // shopify删除的不能下单
    if (oneOrder.isShopifyDelete) {
      return flag;
    }

    // shopify取消的不能下单
    if (oneOrder.detail.cancel_reason && oneOrder.detail.cancelled_at) {
      return flag;
    }

    // 智利税号必填
    if (
      oneOrder.ext &&
      oneOrder.ext.address &&
      oneOrder.ext.address.country_code === 'CL'
    ) {
      if (!checkChileTaxNumberValid(oneOrder.ext.address.rut_no)) {
        return true;
      }
    }

    const countryCode = oneOrder.ext?.address?.country_code;
    const { unsupportedShipping } = this.props;
    oneOrder.childrens.forEach((child, i) => {
      // 加黑商品不能下单 没有订单不能下单
      if (child.is_black_list === 2 || !child.sp) {
        return;
      }

      // canceled tab 下 ae取消的才能再下单
      if (status == 6 && !child.AECanceled.includes(1)) {
        return;
      }

      // shopify待fulfilled的不能下单
      if (child.isPendingFulfillments) {
        return;
      }

      child.sp.forEach((sp, si) => {
        if (sp.status == status) {
          // 选择了该国家不可支持的物流 不可下单
          const isUnsupportShipping =
            unsupportedShipping.Global?.[sp.logistics_company] ||
            unsupportedShipping[countryCode]?.[sp.logistics_company];

          if (isUnsupportShipping) {
            return;
          }

          if (child.supplierMapType == 1) {
            const n = this.getWhichSpCanFulfilled(child); // base mapping 用主供应商还是副供应商
            // 有物流列表才能下单
            if (n == si && sp.freights && sp.freights.length > 0) {
              flag = false;
            }
          }

          // 剩下的mapping类型同样需要有物流列表才能下单
          if (
            child.supplierMapType > 1 &&
            sp.freights &&
            sp.freights.length > 0
          ) {
            flag = false;
          }

          // 比如说一个订单只有一个other单 手动换绑选了 sku和物流 也可以下单
          if (
            this.cacheBind[oneOrder.id] &&
            this.cacheBind[oneOrder.id][`${i}-${si}`] &&
            this.cacheBind[oneOrder.id][`${i}-${si}`].logistics_company
          ) {
            flag = false;
          }
        }
      });
    });
    return flag;
  };

  // 设置订单列表是否可选
  setOrderDisabled = (orderList, status) => {
    orderList.forEach(item => {
      item.canOrderDisabled = this.oneOrderIsDisabled(item, status); // 是否可下单 返回 false 表示不禁用可下单
      item.disabled = status == 9; // 复选框是否禁用
    });
    return orderList;
  };

  // tab下的描述点击here发送GA统计
  tabTipGA = e => {
    const {
      target: {
        dataset: { ga }
      }
    } = e;

    if (ga) {
      reactGaEvent({
        category: 'Order',
        action: ga
      });
    }
  };

  // tab下面的文案提示
  returnTextTip = status => {
    let str = null;
    switch (status) {
      case 1:
        str = intl.getHTML('order.tab_tip.pending');
        break;
      case 2:
        str = intl.getHTML('order.tab_tip.awaiting_order');
        break;
      case 3:
        str = intl.getHTML('order.tab_tip.awaiting_payment');
        break;
      case 4:
        str = intl.getHTML('order.tab_tip.awaiting_shipment');
        break;
      case 7:
        str = intl.getHTML('order.tab_tip.failed_orders');
        break;
      case 9:
        str = intl.getHTML('order.tab_tip.awaiting_fulfillment');
        break;
      default:
        str = '';
    }

    if (status == 6) {
      return (
        <>
          <p className={orderStyles.tabTextStyle}>
            {intl.getHTML('order.tab_tip.canceledChange')}
            <Tooltip
              title={
                <span>{intl.getHTML('order.tab_tip.canceledChange_tit')}</span>
              }
            >
              <Icon
                type="question-circle"
                theme="outlined"
                style={{
                  marginLeft: 2,
                  transform: 'scale(.9)'
                }}
              />
            </Tooltip>
            <span style={{ marginLeft: 5 }}>
              {intl.get('order.archived_orders')}
            </span>
          </p>
        </>
      );
    }

    if (status == 5) {
      return (
        <>
          <p className={orderStyles.tabTextStyle}>
            {intl.getHTML('order.tab_tip.fulfilledFirstChange')}
            <span style={{ marginRight: 5 }}>
              <Tooltip
                title={
                  <span>
                    {intl.getHTML('order.tab_tip.fulfilledFirstChange_tit')}
                  </span>
                }
              >
                <Icon
                  type="question-circle"
                  theme="outlined"
                  style={{
                    marginLeft: 2,
                    transform: 'scale(.9)'
                  }}
                />
              </Tooltip>
            </span>
            {intl.getHTML('order.tab_tip.fulfilledDays')}
            <Tooltip
              title={<span>{intl.get('order.tab_tip.fulfilledDays_tit')}</span>}
            >
              <Icon
                type="question-circle"
                theme="outlined"
                style={{
                  marginLeft: 2,
                  transform: 'scale(.9)'
                }}
              />
            </Tooltip>
          </p>
        </>
      );
    }

    return (
      <p className={orderStyles.tabTextStyle} onClick={this.tabTipGA}>
        {str}
        {[1, 2, 7].includes(status) ? (
          <span style={{ marginLeft: 5 }}>
            {intl.get('order.archived_orders')}
          </span>
        ) : null}
      </p>
    );
  };

  handleBannerClick = data => {
    const { dispatch } = this.props;
    dispatch({
      type: 'global/showOneClickMapping',
      payload: data
    });

    dispatch({
      type: 'global/dataTrack',
      payload: {
        data: {
          user_id: this.props.userInfo.user_id,
          store_id: data.store_id.toString(),
          platform: 'shopify',
          page: 'order list',
          page_url: window.location.href,
          module: 'order',
          action: 'switch-button-click',
          product_id_list: [''],
          order_id_list: [''],
          custom_info: [
            {
              name: 'switch_version',
              value: getVersion(this.props.userInfo.user_id)
            },
            {
              name: 'ae_product_id',
              value: data.ae_product_id.toString()
            },
            {
              name: 'dsers_product_id',
              value: data.dsers_product_id.toString()
            },
            {
              name: 'dsers_product_id',
              value: data.dsers_product_id.toString()
            },
            {
              name: 'shopify_product_id',
              value: data.shopify_product_id.toString()
            },
            {
              name: 'mapping_type',
              value: data.mapping_type.toString()
            }
          ]
        }
      }
    });
  };

  closePay = ()=>{
    this.setState({
      gopay : false
    })
  }


  // 获取空白单
  getEmptyOrder = orderList => {
    const emptyOrderIds = [];
    const { status } = this.state;

    orderList.forEach(order => {
      const flag = order.childrens.some(child => {
        const mapType = child.supplierMapType;

        return child.sp.some((sp, i) => {
          if (mapType == 1 && i != this.getWhichSpCanFulfilled(child)) {
            return false;
          }
          return status == 9 ? [4, 5].includes(sp.status) : sp.status == status;
        });
      });

      !flag && emptyOrderIds.push(order.id);
    });

    return emptyOrderIds;
  };

  // 向后台发送空白单
  sendEmptyOrders = orderList => {
    const emptyOrderIds = this.getEmptyOrder(orderList);
    if (emptyOrderIds.length) {
      this.props.dispatch({
        type: 'topBtn/emptyorders',
        payload: {
          data: {
            order_id: emptyOrderIds
          },
          cancelMessage: true
        }
      });
    }
  };

  showSyncTimeRange = () => {
    // blerlo  未下载插件 --Sync via DSers Chrome Extension)
    if (!window.CHROME_PLUG_INSTALL) {
      window.EVENT.emit(
        GuildeAction.OblerloGuide_Pop,
        `CHROME-${Date.now()}`,
        true
      );
      return;
    }
    window.EVENT.emit(OrderAction.INTERACTION_DOT, {
      action:'click_sync_t_number',
      trans_from:'click button button_text: Sync the latest Tracking Number with the Chrome Extension'
    });
    this.setState({
      showSyncTimeRange: true
    });
  };

  closeSyncTimeRange = () => {
    this.setState({
      showSyncTimeRange: false
    });
  };

  syncTask = async ([start, end] = []) => {
    if (
      ![EXT_VERSION.HIGHER, EXT_VERSION.EQUAL].includes(
        checkExtVersion(2, 8, 5)
      )
    ) {
      console.log(checkExtVersion(2, 8, 5));
      message.info('require dsers chrome extension ver 2.8.5');
      return;
    }
    this.setState({
      aliLoading: true,
      showSyncTimeRange: false
    });

    const response = await sendRequestToExtension(
      'syncAliOrderNumber',
      'createSyncTask',
      { forceCreateTask: true, type: 2, start, end }
    );
    if (response.code === 2000) {
      // eslint-disable-next-line react/no-string-refs
      if (this.refs.syncAliProcess) {
        // eslint-disable-next-line react/no-string-refs
        this.refs.syncAliProcess.startRolling(2, response.data);
      }
    } else if (response.code === 4999) {
      window.open(getChromeExtUrl(), '_blank');
      this.setState({
        aliLoading: false
      });
    } else {
      this.setState({
        aliLoading: false
      });
    }
  };

  syncUnfulfillTask = async () => {
    const {
      userInfo: { user_id }
    } = this.props;
    CommonDataCollect({
      user_id: user_id,
      event_type: 'subscription_analysis',
      action: 'chrome_synchronization_ae_order'
    });

    // blerlo  未下载插件 --Sync via DSers Chrome Extension)
    if (!window.CHROME_PLUG_INSTALL) {
      window.EVENT.emit(
        GuildeAction.OblerloGuide_Pop,
        `CHROME-${Date.now()}`,
        true
      );
      return;
    }

    if (
      ![EXT_VERSION.HIGHER, EXT_VERSION.EQUAL].includes(
        checkExtVersion(2, 8, 5)
      )
    ) {
      // console.log(checkExtVersion(2, 8, 5))
      message.info('require dsers chrome extension ver 2.8.5');
      return;
    }
    this.setState({
      aliLoading: true
    });
    const response = await sendRequestToExtension(
      'syncAliOrderNumber',
      'createSyncTask',
      { type: 1 }
    );
    if (response.code === 2000) {
      // eslint-disable-next-line react/no-string-refs
      if (this.refs.syncAliProcess) {
        // eslint-disable-next-line react/no-string-refs
        this.refs.syncAliProcess.startRolling(1, response.data);
      }
    } else if (response.code === 4999) {
      // window.open(getChromeExtUrl(), '_blank');
      // window.EVENT.emit(ChromeAction.NO_INSTALL_MODAL_RELOAD, true)
      window.EVENT.emit(ChromeAction.NO_INSTALL_MODAL, true);
      this.setState({
        aliLoading: false
      });
    } else {
      this.setState({
        aliLoading: false
      });
    }
  };

  closeSyncLoading = () => {
    this.setState({
      aliLoading: false
    });
  };

  openSyncLoading = () => {
    this.setState({
      aliLoading: true
    });
  };

  checkIsNewUserWithoutAe = () =>
    localStorage.getItem('aliExpressAuthStatus') === 'false' &&
    localStorage.getItem('newUserWithoutAe') === 'true';

  showNewUserAeModal = () => this.setState({ isNewUserAeModalShow: true });

  closeNewUserAeModal = () => this.setState({ isNewUserAeModalShow: false });

  setConfirmChecked = e => {
    const { checked } = e.target;
    if (checked) {
      localStorage.setItem('noPayPalReminder', true);
    } else {
      localStorage.removeItem('noPayPalReminder');
    }
  };

  closeModal = () => {
    this.setState({
      guideModal: false
    });
  };

  closePayPalModal = () => {
    this.setState({
      showPayPalModal: false
    });
    localStorage.setItem('lastShow', Date.now());
  };

  storeData = []; // 商店列表

  list = []; // 订单列表数据

  countObj = {
    all: 0,
    awaiting_order: 0,
    awaiting_payment: 0,
    awaiting_shipment: 0,
    awaiting_fulfilled: 0,
    canceled: 0,
    failed: 0,
    fulfilled: 0,
    pending: 0
  };

  cancenCount = {
    all: 0,
    awaiting_order: 0,
    awaiting_payment: 0,
    awaiting_shipment: 0,
    awaiting_fulfilled: 0,
    canceled: 0,
    failed: 0,
    fulfilled: 0,
    pending: 0
  }

  listMap = null; // 订单 id map

  originListMap = null; // 原订单 id map

  currentLanguage = getLanguage();

  removedVariants = {};

  hideArchiveOrders = () => {
    this.setState({
      showArchive: false
    });
    this.getOrderList();
  };

  //切换flags
  changesFlags = (val, index) => {
    const { flagsList } = this.state;

    if(this.props.loading){
      return
    }

    let list = flagsList.map(item => {
      if (item.id == val.id) {
        return {
          ...item,
          checked: !item.checked
        };
      } else {
        return item;
      }
    });


    //把缓存的值给删掉

    this.cancelFlags = this.cancelFlags.map(item => {
      if(item.id == val.id){
        return {
          ...item,
          checked:false
        }
      }else{
        return item
      }
    })

    this.cancelIndex.forEach((item, index)=>{
      if(val.id == item){
        this.cancelIndex.splice(index,1)
      }
    })

    let canceData = JSON.parse(localStorage.getItem('CUSTOMIZATION_USER_ACTION_V3'))

    localStorage.setItem('CUSTOMIZATION_USER_ACTION_V3',JSON.stringify({
      ...canceData,
      flags:this.cancelFlags
    }))

    console.log(this.cancelFlags, this.cancelIndex)


    const {
      userInfo: { user_id }
    } = this.props;
    CommonDataCollect({
      user_id: user_id,
      event_type: 'subscription_analysis',
      action: 'flags_search_orders'
    });

    this.setState(
      {
        flagsList: list
      },
      () => {
        this.getOrderList();
      }
    );
  };

  //绑定AE
  linkOrderTipBindAe = () => {
    if (!window.IS_BIND_AE) {
      window.EVENT.emit(
        GuildeAction.OblerloGuide_Pop,
        `AE-${Date.now()}`,
        true
      );
      return;
    }
  };

  filt = (orderList = [], status) => {

    const { filteringMappStatus } =  this.state

    let MapStatus = {}
    let MapList = {}
    let deleteMapList = {}
    let flag = false
    let orderListFilter = []

    // if(![2,6,7].includes(status)){
    //   return orderList
    // }

    //重新计算list
    let deepList = cloneDeep(orderList)
    let newOrderList = []

    if(status == 2){
      newOrderList = deepList.map(lineItem => {
        return {
          ...lineItem,
          childrens : lineItem.childrens.filter(cItem => {
            if(cItem.status & status){
              return cItem
            }
          })
        }
      })
    }

    if(status == 6){
      let keyAeArr = []
      newOrderList = deepList.map(lineItem => {
        return {
          ...lineItem,
          childrens : lineItem.childrens.filter(cItem => {
            if([16,32,48].includes(cItem.status)){
              if(cItem.AECanceled[0] == 1){
                keyAeArr.push(lineItem.id)
              }
              return cItem
            }
          })
        }
      })
      if([2,3].includes(filteringMappStatus?.id)){
        newOrderList = newOrderList.filter(item => {
          return keyAeArr.includes(item.id)
        })
      }
    }

    if(status == 7){
      newOrderList = deepList.map(lineItem => {
        return {
          ...lineItem,
          childrens : lineItem.childrens.filter(cItem => {
            if([32,48,2080].includes(cItem.status)){
              return cItem
            }
          })
        }
      })
    }

    if([1,3,4,9,5].includes(status)){
      newOrderList = deepList
    }
    //如果是 2 6 7  
    if([2,6,7].includes(status)){
      newOrderList?.map((orderItem, index) => {
        orderItem?.childrens?.map(childItem => {
          childItem?.sp?.map(spItem => {
            if(spItem.status == status){
              flag = true;
            }else{
              flag = false;
            }
  
            if(flag){
              MapStatus[orderItem?.id] = status+'-'+childItem.status
            }
          })
        })
      })
  
      newOrderList?.map(orderItem => {
        orderItem?.childrens?.map(childItem => {
          //判断外层status  不能是包含--精准匹配
          let neiStaus = MapStatus[orderItem?.id]?.split('-')[0]
          let difStaus = MapStatus[orderItem?.id]?.split('-')[1]
          if(neiStaus == 6){
            // 只有ae canceld的能下单
            if(childItem.AECanceled[0] == 1 && difStaus == childItem.status){
              if(!childItem.is_black_list){
                childItem?.sp?.map(spItem => {
                  if(
                    spItem.status == status 
                    && spItem.platform_product_id 
                    && spItem.platform_sku
                    ){
                    MapList[orderItem?.id] = 1
                  }
                })
              }
            }
          }else{
            if(difStaus == childItem.status){
              if(!childItem.is_black_list && childItem.platform_type == 4){
                childItem?.sp?.map(spItem => {
                  if(
                    spItem.status == status 
                    && spItem.platform_product_id 
                    && spItem.platform_sku
                    ){
                    MapList[orderItem?.id] = 1
                  }else{
                    deleteMapList[orderItem?.id] = 2
                  }
                })
              }
            }
          }
        })
      })

      if(filteringMappStatus?.id == 2){
        let deleteKey = Object.keys(deleteMapList)
        if(deleteKey.length){
          deleteKey.map(item => {
            delete MapList[item]
          })
        }
        let arr = []
        newOrderList.map(orderItem => {
          Object.keys(MapList).map(mapKey => {
            if(orderItem.id == mapKey){
              orderListFilter.push(orderItem)
            }
          })
        })
      }
  
      if(filteringMappStatus?.id == 3){
        let deleteKey = Object.keys(deleteMapList)
        if(deleteKey.length){
          deleteKey.map(item => {
            delete MapList[item]
          })
        }
        let arr = []
        let keys = Object.keys(MapList)
        orderListFilter = newOrderList.filter(item => {
          return keys.indexOf(item.id) < 0
        })
        
      }
    }

    if([1].includes(status)){
      newOrderList.map(orderItem => {
        orderItem.childrens.map(childrenItem => {
          childrenItem.sp.map(spItem => {
            if(spItem.status == 5){
              if(spItem.platform_product_id && spItem.platform_sku){
                MapList[orderItem?.id] = 1
              }else{
                deleteMapList[orderItem?.id] = 2
              }
            }
          })
        })
      })

      if(filteringMappStatus?.id == 2){
        let deleteKey = Object.keys(deleteMapList)
        if(deleteKey.length){
          deleteKey.map(item => {
            delete MapList[item]
          })
        }
        let arr = []
        newOrderList.map(orderItem => {
          Object.keys(MapList).map(mapKey => {
            if(orderItem.id == mapKey){
              orderListFilter.push(orderItem)
            }
          })
        })
      }
  
      if(filteringMappStatus?.id == 3){
        let deleteKey = Object.keys(deleteMapList)
        if(deleteKey.length){
          deleteKey.map(item => {
            delete MapList[item]
          })
        }
        let arr = []
        let keys = Object.keys(MapList)
        orderListFilter = newOrderList.filter(item => {
          return keys.indexOf(item.id) < 0
        })
        
      }
    }


    if([3].includes(status)){
      newOrderList.map(orderItem => {
        orderItem.childrens.map(childrenItem => {
          childrenItem.sp.map(spItem => {
            if(spItem.status == status){
              if(spItem.platform_product_id && spItem.platform_sku){
                MapList[orderItem?.id] = 1
              }else{
                deleteMapList[orderItem?.id] = 2
              }
            }
          })
        })
      })
      if(filteringMappStatus?.id == 2){
        let deleteKey = Object.keys(deleteMapList)
        if(deleteKey.length){
          deleteKey.map(item => {
            delete MapList[item]
          })
        }
        let arr = []
        newOrderList.map(orderItem => {
          Object.keys(MapList).map(mapKey => {
            if(orderItem.id == mapKey){
              orderListFilter.push(orderItem)
            }
          })
        })
      }
  
      if(filteringMappStatus?.id == 3){
        let deleteKey = Object.keys(deleteMapList)
        if(deleteKey.length){
          deleteKey.map(item => {
            delete MapList[item]
          })
        }
        let arr = []
        let keys = Object.keys(MapList)
        orderListFilter = newOrderList.filter(item => {
          return keys.indexOf(item.id) < 0
        })
        
      }
    }
    
    if([9].includes(status)){
      newOrderList.map(orderItem => {
        orderItem.childrens.map(childrenItem => {
          childrenItem.sp.map(spItem => {
            if(spItem.status == 5){
              if(spItem.platform_product_id && spItem.platform_sku){
                MapList[orderItem?.id] = 1
              }else{
                deleteMapList[orderItem?.id] = 2
              }
            }
          })
        })
      })
      if(filteringMappStatus?.id == 2){
        let deleteKey = Object.keys(deleteMapList)
        if(deleteKey.length){
          deleteKey.map(item => {
            delete MapList[item]
          })
        }
        let arr = []
        newOrderList.map(orderItem => {
          Object.keys(MapList).map(mapKey => {
            if(orderItem.id == mapKey){
              orderListFilter.push(orderItem)
            }
          })
        })
      }
  
      if(filteringMappStatus?.id == 3){
        let deleteKey = Object.keys(deleteMapList)
        if(deleteKey.length){
          deleteKey.map(item => {
            delete MapList[item]
          })
        }
        let arr = []
        let keys = Object.keys(MapList)
        orderListFilter = newOrderList.filter(item => {
          return keys.indexOf(item.id) < 0
        })
        
      }
    }

    if([5].includes(status)){
      newOrderList.map(orderItem => {
        orderItem.childrens.map(childrenItem => {
          childrenItem.sp.map(spItem => {
            if(spItem.status == 5){
              if(spItem.platform_product_id && spItem.platform_sku){
                MapList[orderItem?.id] = 1
              }else{
                deleteMapList[orderItem?.id] = 2
              }
            }
          })
        })
      })

      console.log('MapList', MapList)

      if(filteringMappStatus?.id == 2){
        let deleteKey = Object.keys(deleteMapList)
        if(deleteKey.length){
          deleteKey.map(item => {
            delete MapList[item]
          })
        }
        let arr = []
        newOrderList.map(orderItem => {
          Object.keys(MapList).map(mapKey => {
            if(orderItem.id == mapKey){
              orderListFilter.push(orderItem)
            }
          })
        })
      }
  
      if(filteringMappStatus?.id == 3){
        let deleteKey = Object.keys(deleteMapList)
        if(deleteKey.length){
          deleteKey.map(item => {
            delete MapList[item]
          })
        }
        let arr = []
        let keys = Object.keys(MapList)
        orderListFilter = newOrderList.filter(item => {
          return keys.indexOf(item.id) < 0
        })
        
      }
    }

    if([4].includes(status)){
      newOrderList.map(orderItem => {
        orderItem.childrens.map(childrenItem => {
          childrenItem.sp.map(spItem => {
            if(spItem.status == 4){
              if(spItem.platform_product_id && spItem.platform_sku){
                MapList[orderItem?.id] = 1
              }else{
                deleteMapList[orderItem?.id] = 2
              }
            }
          })
        })
      })

      console.log('MapList', MapList)

      if(filteringMappStatus?.id == 2){
        let deleteKey = Object.keys(deleteMapList)
        if(deleteKey.length){
          deleteKey.map(item => {
            delete MapList[item]
          })
        }
        let arr = []
        newOrderList.map(orderItem => {
          Object.keys(MapList).map(mapKey => {
            if(orderItem.id == mapKey){
              orderListFilter.push(orderItem)
            }
          })
        })
      }
  
      if(filteringMappStatus?.id == 3){
        let deleteKey = Object.keys(deleteMapList)
        if(deleteKey.length){
          deleteKey.map(item => {
            delete MapList[item]
          })
        }
        let arr = []
        let keys = Object.keys(MapList)
        orderListFilter = newOrderList.filter(item => {
          return keys.indexOf(item.id) < 0
        })
        
      }
    }


    return orderListFilter
  }

  renderFilterMapping = () => {

    const { filteringMapp, filteringMappStatus, status} = this.state
    const { userInfo } = this.props

    //定制化需求
    if(!CUSTOMIZATION_USER.includes(userInfo.user_id)){
      return null
    }

    // if(![2,6,7].includes(status)){
    //   return null
    // }

    return <>
      <div className="flags">
        <img
          className="imagesb mapping"
          src={require('../../assets/newImportList/icon-mapping.svg')}
        />
        {filteringMappStatus?.name || intl.get('order.filter_mapping_default')}
        <img
          className="down"
          src={require('../../assets/newImportList/icon_expand_more-24px.png')}
        ></img>
        <ul className="flags-list">
          {filteringMapp.map((item, index) => {
            return (
              <li
                key={item.id}
                className={item.checked ? 'active' : null}
                onClick={() => {
                  this.changesfilterMapping(item);
                }}
              >
                <p>{item.name}</p>
              </li>
            );
          })}
        </ul>
      </div>
    </>
  }

  changesfilterMapping = item => {
    this.setState({
      filteringMappStatus:item,
      selectedRows: [],
      selectedRowsId: []
    },() => {
      this.getOrderList()
    })
  }

  closeBannber = () => {
    localStorage.setItem('attention', true)
    this.setState({
      attention: true
    })
  }

  getEditList = () => {
    if(window.MAPPING_STATUS){
      if(window?.MAPPING_VALUE?.hasOwnProperty('id')){
        this.onlySaveOrder(window.MAPPING_VALUE.id,false,true,'')
        window.MAPPING_VALUE = {}
        window.MAPPING_STATUS = false;
      }
    }
  }
  defaultstartDatetime = moment(this.startDatetime * 1000).format('YYYY-M-DD')
  defaultEndDatetime = moment(this.endDatetime * 1000).format('YYYY-M-DD')
  actionStatus = JSON.parse(localStorage.getItem('actionStatus_v3'))


  //需要记录下时间 confirm时用
  cancenData = {
    startTime:{
      startDatetime:this.startDatetime,
      SDate:this.defaultstartDatetime
    },
    endTime:{
      endDatetime: this.endDatetime,
      EDate:this.defaultEndDatetime
    },
    timeZone:this.timeZone,
    country:'',
    filteringMappStatus:{}
  }

  onChangeTime = (type, m) => {
      this.isSelectDate = true;
      if(type == 'startTime'){
      this.cancenData[type]['startDatetime'] = m.startOf('day').unix();
      this.cancenData[type]['SDate'] = `${m.year()}-${m.month() + 1}-${m.date()}`;
    }else{
      this.cancenData[type]['endDatetime'] = m.startOf('day').unix();
      this.cancenData[type]['EDate'] = `${m.year()}-${m.month() + 1}-${m.date()}`;
    }
  }

  onChangeCustTime = (e) => {
    // this.dateRadioDefaultType = e.target.value
    this.setState({
      dateRadioDefaultType: e.target.value
    })

  }

  getTimeDom = () => {
    // 本来一个RangePicker能搞定的  非得拆开俩个来写

    const { dataType, dateRadioDefaultType } = this.state

    const dateFormat = 'YYYY-M-DD';
    let startDatetime = moment(this.startDatetime * 1000).format('YYYY-MM-DD')
    let endDatetime = moment(this.endDatetime * 1000).format('YYYY-MM-DD')
    return <>
      <div className={classnames({
        [radioStyles.SearchBox]:true,
        [radioStyles.SearchBox_active]:true
      })} data-type="getTimeDom">
        <Radio.Group onChange={this.onChangeCustTime} defaultValue={dateRadioDefaultType}>
          {
            dataType.map(item => {
              return <Radio key={item.type} value={item.type}>{item.name}</Radio>
            })
          }
          <Radio key={9} value={6}>
            <div className={orderStyles.datePicker}>
              <div>Custom</div>
              <div className='DatePicker_box'>
                <p className='form'>From</p>
                <DatePicker
                  style={{width:'100%'}}
                  disabled={dateRadioDefaultType == 6 ? false : true} 
                  defaultValue={moment(startDatetime, dateFormat)} 
                  format={dateFormat}
                  onChange={e => this.onChangeTime('startTime', e)}
                />
                <span className='data_icon'>
                    <i
                      style={{ fontSize: 18, marginTop: '8px' }}
                      className="material-icons"
                    >
                      calendar_today
                    </i>
                  </span>
              </div>
              <div className='DatePicker_box'>
                <p className='form'>To</p>
                <DatePicker 
                  style={{width:'100%'}}
                  disabled={dateRadioDefaultType == 6 ? false : true} 
                  defaultValue={moment(endDatetime, dateFormat)} 
                  format={dateFormat}
                  onChange={e => this.onChangeTime('endTime', e)}
                />
                <span className='data_icon'>
                  <i
                    style={{ fontSize: 18, marginTop: '8px' }}
                    className="material-icons"
                  >
                    calendar_today
                  </i>
                </span>
              </div>
            </div>
          </Radio>
        </Radio.Group>
      </div>
    </>
  }

  getOrderTypeDom = () => {
    const { filteringMapp } = this.state 
    return <>
      <FilterSearch
        dataSource={filteringMapp}
        defaultValue={this.state.filteringMappStatus?.id || 1}
        gruopType="orderType" 
        effectsAction={{
          onChangeOrderType: (e) => {
            let arr = filteringMapp.find(item => item.id == e.target.value)
            this.cancenData.filteringMappStatus = arr
          },
        }} />
    </>
  }

  getTimeZoneDom = () => {
    return <>
      <FilterSearch
        dataSource={timezone}
        defaultValue={this.state.settingTimeZone}
        gruopType="timeZone" 
        effectsAction={{
          onChangeTimeZone: (e) => {
            this.cancenData['timeZone'] = e
          },
        }} />
    </>
  }

  getCountryDom = () => {
    return <>
      <FilterSearch
        dataSource={this.countryLists}
        defaultValue={this.statusCountry}
        gruopType="country" 
        effectsAction={{
          onChangeCountry: (e) => {
            this.cancenData['country'] = e
          },
        }} />
    </>
  }

  cancelIndex = []

  getFlagsDom = () => {
    
    const { flagsList } = this.state

    return <>
      <FilterSearch
        dataSource={flagsList}
        defaultValue={[...new Set(this.cancelIndex)]}
        gruopType="flags" 
        effectsAction={{
          onChangeFlags: e => {
              console.log(e)
              this.cancelIndex = e
          }
        }} />
    </>
  }

  cancelFlags = [
    {
      id: 0,
      img: 'https://img.dsers.com/images/order-flags-icon/11.png',
      name: intl.get('order.flags.None'),
      checked: false
    },
    {
      id: 1,
      img: 'https://img.dsers.com/images/order-flags-icon/22.png',
      name: intl.get('order.flags.Grey'),
      checked: false
    },
    {
      id: 2,
      img: 'https://img.dsers.com/images/order-flags-icon/33.png',
      name: intl.get('order.flags.Blue'),
      checked: false
    },
    {
      id: 3,
      img: 'https://img.dsers.com/images/order-flags-icon/44.png',
      name: intl.get('order.flags.Green'),
      checked: false
    },
    {
      id: 4,
      img: 'https://img.dsers.com/images/order-flags-icon/55.png',
      name: intl.get('order.flags.Yellow'),
      checked: false
    },
    {
      id: 5,
      img: 'https://img.dsers.com/images/order-flags-icon/66.png',
      name: intl.get('order.flags.Red'),
      checked: false
    }
  ]

  dateRadioDefaultType = 3;

  //search确认弹窗
  onFilterConfirm = (type = '', flag = false) => {
    const { flagsList } = this.state
    let arr = this.cancelFlags.map(flagListItem => {
      if(this.cancelIndex.includes(flagListItem.id)){
        return {
          ...flagListItem,
          checked: true
        }
      }else{
        return {
          ...flagListItem,
          checked: false
        }
      }
    })
    this.cancelFlags = arr
    this.isTimeShow = true;

    if(!flag){
      this.setState({
        filteringMappStatus: this.cancenData.filteringMappStatus
      })
    }

    this.setState({
      tagVisiable:true
    })

    let zone;
    let actionStatus = JSON.parse(localStorage.getItem('actionStatus_v3'))
    if(this.cancenData.timeZone){
      zone = this.cancenData.timeZone

      this.setState({
        settingTimeZone: zone
      })

    }else{
      zone = this.state.settingTimeZone;
    }
    this.SDate = this.cancenData.startTime.SDate
    this.EDate = this.cancenData.endTime.EDate

    if(this.isSelectDate){
      let NoData = JSON.parse(localStorage.getItem('CUSTOMIZATION_USER_ACTION_V3'))

      localStorage.setItem('CUSTOMIZATION_USER_ACTION_V3', JSON.stringify({
        ...NoData,
        EDate: this.EDate,
        SDate: this.SDate ,
      }))
    }
    this.statusCountry = this.cancenData.country
    if(type == 'country'){
      this.statusCountry = ''
    }
    if(type == 'timezone'){
      zone = actionStatus.timeZone
    }
    if(type == 'time'){
      this.SDate = actionStatus.SDate
      this.EDate = actionStatus.EDate

      //清除缓存里的时间
      this.cancenData.startTime.startDatetime = actionStatus.startDatetime
      this.cancenData.startTime.SDate = actionStatus.SDate
      this.cancenData.endTime.endDatetime = actionStatus.endDatetime
      this.cancenData.endTime.EDate = actionStatus.EDate

    }
    
    
    this.dateRadioDefaultType = this.state.dateRadioDefaultType

    if(this.dateRadioDefaultType !== 6){
      this.isSelectDate = false
      this.getCusUTCStartEnd(zone)
      let NoData = JSON.parse(localStorage.getItem('CUSTOMIZATION_USER_ACTION_V3'))

      localStorage.setItem('CUSTOMIZATION_USER_ACTION_V3', JSON.stringify({
        ...NoData,
        dateRadioDefaultType:this.dateRadioDefaultType,
        timeZone:this.cancenData.timeZone,
        country:this.cancenData.country,
        flags:this.cancelFlags,
      }))
    }else{
      this.getUTCStartEnd(zone, true, true)
      let NoData = JSON.parse(localStorage.getItem('CUSTOMIZATION_USER_ACTION_V3'))

      localStorage.setItem('CUSTOMIZATION_USER_ACTION_V3', JSON.stringify({
        ...NoData,
        dateRadioDefaultType:this.dateRadioDefaultType,
        timeZone:this.cancenData.timeZone,
        country:this.cancenData.country,
        flags:this.cancelFlags,
      }))
    }

    this.setState({
      drawerVisiable:false
    })
  }

  showDeleteSearch = () => {
    // 鼠标经过搜索框是否展示删除图标
    if (this.searchKey) {
      this.setState({ showDeleteSearch: true });
    }
  };

  // 鼠标离开搜索框隐藏删除图标
  hideDeleteSearch = () => {
    this.setState({ showDeleteSearch: false });
  };

  onClearFilterComfig = () => {
    const {
      userInfo: { stores, has_import, tutorial_type, user_id },
    } = this.props;

    this.statusCountry = '';
    let actionStatus = JSON.parse(localStorage.getItem('actionStatus_v3'))
    let flagsArr = this.state.flagsList.map(item => {
      return {
        ...item,
        checked:false
      }
    })
    this.cancelIndex = []
    this.SDate = actionStatus.SDate
    this.EDate = actionStatus.EDate
    this.cancenData.timeZone = actionStatus.timeZone
    this.cancelFlags=[]
    this.setState({
      flagsList:flagsArr,
      settingTimeZone: actionStatus.timeZone
    }, () => {
      this.getUTCStartEnd(actionStatus.timeZone, true)
    })

    if(CUSTOMIZATION_USER.includes(user_id)){
      this.setState({
        filteringMappStatus:{
          id:2,
          name:intl.get('order.filter_mapped_order'),
        }
      })
      this.cancenData.filteringMappStatus = {
        id:2,
        name:intl.get('order.filter_mapped_order'),
      }
    }
    this.cancenData.country = ''
    localStorage.setItem('CUSTOMIZATION_USER_ACTION_V3',JSON.stringify({
      EDate:actionStatus.EDate,
      SDate:actionStatus.SDate,
      timeZone:actionStatus.timeZone,
      startDatetime:actionStatus.startDatetime,
      endDatetime:actionStatus.endDatetime,
      filteringMappStatus:this.cancenData.filteringMappStatus,
      country:'',
      flags:flagsArr,
      size:40
    }))

    this.setState({
      drawerVisiable:false,
      tagVisiable:false,
      dateRadioDefaultType:3
    })
    this.dateRadioDefaultType = 3
    this.isTimeShow = false;
  }

  searchFilterOrder = (type) => {

    const {
      orderList = [], // 订单列表
      selectedRows = [], // 选中的订单
      showGlobalPlaceOrder, // 是否显示页面中间的下单按钮
      showDeleteSearch, // 是否显示搜索内容删除图标
      searchKey, // 搜索内容
      showMapping, // 是否展示商品mapping
      bindAliCardShow, // 是否展示绑ae弹窗
      isSync, // 是否正在同步shopify订单
      visibleFulfillOrdersManuallyTip,
      status, // tab status 当前在哪个tab下
      showPlaceOrder, // 是否显示下单弹窗
      showFulfilledModal, // 是否显示手动fulfilled弹窗
      showRollBack, // 是否展示回滚弹窗
      showOrderResult, // 是否展示下单结果
      mappingProduct, // 设置maping的商品
      awaitingOrderNumber, // 下单结果 等待下单的订单数量
      succeedOrderNumber, // 下单结果 下单成功的订单数量
      failedOrderNumber, // 下单结果 下单失败的订单数量
      showRefreshMask, // 是否显示刷新页面弹窗
      showReviewBanner,
      sumSync,
      // placeOrderType,
      bannerData,
      checkAeModalType,
      isNewUserAeModalShow,
      showArchive,
      showPayPalModal,
      tutorial_type,
      flagsList,
      filteringMapp,
      filteringMappStatus,
      attention
    } = this.state;

    const extensionVersion =
      typeof window.dsersExtVersion === 'string' &&
      window.dsersExtVersion.split('.');

    const showExtSyncTn =
      extensionVersion &&
      extensionVersion.length === 3 &&
      parseInt(extensionVersion[0]) >= 2 &&
      parseInt(extensionVersion[1]) >= 8 &&
      parseInt(extensionVersion[2]) >= 4;


    if(type == 'search'){
      return <>
      <div className='inputBoxSearch'>
        <div className="filterBox" onClick={() => {
          this.setState({
            searchFlag:true,
            searchFlagBtn:true
          },() => {
            if (this.textInput) this.textInput.focus();
          })
          setTimeout(()=>{
            this.setState({
              hidden:false
            })
          },600)
        }}>
              <i id="filterTextIcon" class="material-icons notranslate">search</i>
              <span id="filterText" className='filterText'>{intl.get('order.search_type.searchOrder')}</span>
         </div>
        {
          this.state.searchFlag ? null : 
          <div className='inputBox'>
            <InputGuide />
          </div>
        }
        </div>
      </>
    }
    if(type == 'filter'){
      return <>
        <div className='filterBox' onClick={() => {
          this.setState({
            drawerVisiable:true,
          })
        }}>
          <i class="material-icons notranslate">filter_alt</i>
          <span className='filterText'>{intl.get('import_list.filter')}</span>
        </div>
      </>
    }
  }

  isTimeShow = false;
  openDrawer = () => {
    this.setState({
      drawerVisiable:true
    })
  }

    //计算tag
    selectTag = () => {
      const {
        userInfo: { stores, has_import, tutorial_type, user_id },
      } = this.props;
  
      let SelectCountry = this.countryLists.find(item => item.Code == this.statusCountry)
      let TimeZone = timezone.find(item => item.value == this.cancenData.timeZone)
      let actionStatus = JSON.parse(localStorage.getItem('actionStatus_v3'))
      let TimeShow = this.state.confirmSelect && this.SDate && this.EDate
  
      if(window.location.href.includes('start_at') && window.location.href.includes('end_at')){
        let startDatetime = getQueryUrlParams(window.location.href, 'start_at');
        let endDatetime = getQueryUrlParams(window.location.href, 'end_at')
        this.SDate = moment(startDatetime * 1000).format('YYYY-MM-DD')
        this.EDate = moment(endDatetime * 1000).format('YYYY-MM-DD')
      }
  
      // if(CUSTOMIZATION_USER.includes(user_id)){
      //   if(TimeShow){
      //     let data = JSON.parse(localStorage.getItem('CUSTOMIZATION_USER_ACTION_V3'))
      //     if(data){
      //       if(this.CouputedTime(data?.SDate) == actionStatus.SDate && this.CouputedTime(data?.EDate) == actionStatus.EDate){
      //         TimeShow = false
      //       }else{
      //         TimeShow = true
      //         if(this.dateRadioDefaultType !== 6){
      //           TimeShow = false
      //         }
      //       }
      //     }
      //   }else{
      //     let data = JSON.parse(localStorage.getItem('CUSTOMIZATION_USER_ACTION_V3'))
      //     if(data){
      //       if(this.CouputedTime(data?.SDate) == actionStatus.SDate && this.CouputedTime(data?.EDate) == actionStatus.EDate){
      //         TimeShow = false
      //       }else{
      //         TimeShow = true
             
      //       }
      //     }
      //   }
      // }else{
      //   //如果是默认搜索 就直接展示时间
      //   if(window.location.href.includes('orderKey')){
      //     TimeShow = true
      //   }else{
      //     if(TimeShow){
      //       //再看时间是不是默认时间
      //       if(actionStatus){
      //         if(actionStatus?.EDate == this.CouputedTime(this.EDate) && actionStatus?.SDate == this.CouputedTime(this.SDate)){
      //           TimeShow = false
      //         }else{
      //           TimeShow = true
                
      //         }
      //       }
      //     }
      //   }
      // }
      if(this.dateRadioDefaultType == 6||this.dateRadioDefaultType == 5||this.dateRadioDefaultType == 4||this.dateRadioDefaultType == 2||this.dateRadioDefaultType == 1){
        TimeShow = true
        this.setState({
          istimeShow:true
        })
      }else{
        if(this.dateRadioDefaultType == 3){
          if(this.isTimeShow){
            TimeShow = true;
          }else{
            TimeShow = false
          }
        }else{
          TimeShow = false
        }
      }
  
  
      let TimeZoneShow;
      if(TimeZone){
        TimeZoneShow = this.cancenData.timeZone
        if(TimeZoneShow && this.cancenData.timeZone.trim() == actionStatus.timeZone.trim()){
          TimeZoneShow = false
        }else{
          TimeZoneShow = true
        }
      }else{
        TimeZoneShow = false;
      }
  
      return <>
        {/* 国家 */}
        {
          this.statusCountry ? <div  className="flagsTagListItem">
            <p onClick={this.openDrawer}>{SelectCountry.Name}</p>
            <div
              onClick={() => {
                this.onFilterConfirm('country',true)
                this.cancenData.country = ''
                let data = JSON.parse(localStorage.getItem('CUSTOMIZATION_USER_ACTION_V3'))
                localStorage.setItem('CUSTOMIZATION_USER_ACTION_V3',JSON.stringify({
                  ...data,
                  country:''
                }))
              }}
            >
              <img src="https://img.dsers.com/images/order-flags-icon/close.png"></img>
            </div>
          </div> : null
        }
        {/* 时区 */}
        {
          TimeZoneShow  ? <div  className="flagsTagListItem">
          <p onClick={this.openDrawer}>{TimeZone.label}</p>
          <div
            onClick={() => {
              this.onFilterConfirm('timezone',true)
              this.cancenData.timeZone = actionStatus.timeZone
              this.setState({
                settingTimeZone:actionStatus.timeZone
              })
              let data = JSON.parse(localStorage.getItem('CUSTOMIZATION_USER_ACTION_V3'))
              localStorage.setItem('CUSTOMIZATION_USER_ACTION_V3',JSON.stringify({
                ...data,
                timeZone:actionStatus.timeZone
              }))
            }}
          >
            <img src="https://img.dsers.com/images/order-flags-icon/close.png"></img>
          </div>
          </div> : null
        }
        {/* 时间 */}
        {
          TimeShow ? <div  className="flagsTagListItem">
          <p onClick={this.openDrawer}>{moment(this?.startDatetime * 1000).format('YYYY-MM-DD')} ~ {moment(this?.endDatetime * 1000).format('YYYY-MM-DD')} </p>
          <div
            onClick={() => {
              if(window.location.href.includes('orderKey')){
                window.location.href = '/app/order/tmall/list'
                return
              }
              
              // this.setState({
              //   dateRadioDefaultType:3,
              //   istimeShow:false
              // })
              // this.onFilterConfirm('time', true)
              // this.dateRadioDefaultType = 3;

              this.isTimeShow = false
              this.isSelectDate = true
              this.onClearFilterComfig()


              let actionStatus = JSON.parse(localStorage.getItem('actionStatus_v3'))
              let data = JSON.parse(localStorage.getItem('CUSTOMIZATION_USER_ACTION_V3'))
              localStorage.setItem('CUSTOMIZATION_USER_ACTION_V3',JSON.stringify({
                ...data,
                EDate:actionStatus.EDate,
                SDate:actionStatus.SDate
              }))
  
            }}
          >
            <img src="https://img.dsers.com/images/order-flags-icon/close.png"></img>
          </div>
          </div> : null
        }
        {/* 定制化 */}
        {
          this.state.filteringMappStatus?.id && this.state.filteringMappStatus?.id != 1 ? <div  className="flagsTagListItem">
          <p onClick={this.openDrawer}>{this.state.filteringMappStatus?.name}</p>
          <div
            onClick={() => {
              this.setState({
                filteringMappStatus:{}
              })
              this.cancenData.filteringMappStatus = {
                id:1,
                name:intl.get('order.filter_mapped_order'),
              }
              let actionStatus = JSON.parse(localStorage.getItem('actionStatus_v3'))
              let data = JSON.parse(localStorage.getItem('CUSTOMIZATION_USER_ACTION_V3'))
              localStorage.setItem('CUSTOMIZATION_USER_ACTION_V3',JSON.stringify({
                ...data,
                filteringMappStatus:{
                  id:1,
                  name:intl.get('order.filter_mapping_default')
                },
              }))
              this.getOrderList()
            }}
          >
            <img src="https://img.dsers.com/images/order-flags-icon/close.png"></img>
          </div>
          </div> : null
        }
      </>
    }

  inputDom = () => {
    let {
      loading,
      syncCanceledOrderLoading,
      order: { orderData },
      unBindLoading,
      bindLoading,
      lang,
      userInfo
    } = this.props;

    const {
      orderList = [], // 订单列表
      selectedRows = [], // 选中的订单
      showGlobalPlaceOrder, // 是否显示页面中间的下单按钮
      showDeleteSearch, // 是否显示搜索内容删除图标
      searchKey, // 搜索内容
      showMapping, // 是否展示商品mapping
      bindAliCardShow, // 是否展示绑ae弹窗
      isSync, // 是否正在同步shopify订单
      visibleFulfillOrdersManuallyTip,
      status, // tab status 当前在哪个tab下
      showPlaceOrder, // 是否显示下单弹窗
      showFulfilledModal, // 是否显示手动fulfilled弹窗
      showRollBack, // 是否展示回滚弹窗
      showOrderResult, // 是否展示下单结果
      mappingProduct, // 设置maping的商品
      awaitingOrderNumber, // 下单结果 等待下单的订单数量
      succeedOrderNumber, // 下单结果 下单成功的订单数量
      failedOrderNumber, // 下单结果 下单失败的订单数量
      showRefreshMask, // 是否显示刷新页面弹窗
      showReviewBanner,
      sumSync,
      // placeOrderType,
      bannerData,
      checkAeModalType,
      isNewUserAeModalShow,
      showArchive,
      showPayPalModal,
      tutorial_type,
      flagsList,
      filteringMapp,
      filteringMappStatus,
      attention,
      checkLocalAEAccountLoading
    } = this.state;

    // style={this.state.searchFlag ? {opacity:1, visibility:'visible'} : { opacity:0, visibility: 'hidden' }}

    return <div className={this.state.hidden ? 'input_trastion' : 'input_trastion_active'}>
        <div id="order_no_input_box">
          <div className={this.state.searchFlag ? 'order_no_input_box order_no_input_box_active' : 'order_no_input_box'}>
          <div className="order_no_input_box_clearIcon">
                <div className='order_no_input_box_clearIcon_i'>
                  {showDeleteSearch ? (
                    <Icon
                      type="close-circle"
                      theme="filled"
                      onClick={e => {
                        e.stopPropagation();
                        this.deleteSearchKey();
                      }}
                      onMouseEnter={e => {
                        e.stopPropagation();
                        this.showDeleteSearch();
                      }}
                    />
                  ) : null}
                </div>
              </div>    
              <Input
                id="appNei"
                style={{ width: '100%' }}
                addonBefore={this.searchMoreFilter()}
                className={orderStyles.search}
                allowClear={false}
                value={searchKey}
                placeholder={intl.get('order.search_input_placeholder')}
                ref={element => this.textInput = element}
                onChange={e => {
                  this.setState({
                    showDeleteSearch:true
                  })
                  this.changeSearchKey(e);
                }}
                onKeyDown={e => {
                  if (e.keyCode == 13) {
                    this.changeSearch();
                  }
                }}
                onMouseEnter={e => {
                  e.stopPropagation();
                  this.showDeleteSearch();
                }}
                onMouseLeave={e => {
                  e.stopPropagation();
                  this.hideDeleteSearch();
                }}
              
              />
              <button onClick={this.changeSearch} style={this.state.searchFlag ? {display:'block'} : {display:'none'}}>
                <i className="material-icons">search</i>
              </button>
            </div>
        </div>
      </div>
  }

  handleOpenPayment = () => {
    const { selectedRows } = this.state; // 选中的订单
    this.paymentOrderData = selectedRows;
    this.setState({
      showPaymentOrder : true
    })
    CommonDataCollect({
      event_type:'order_payment',
      action:'click_batch_makepayment'
    })
  }

  handleDeatilPayment = () => {
    this.getOrderList()
  }



  render() {
    let {
      loading,
      syncCanceledOrderLoading,
      order: { orderData },
      unBindLoading,
      bindLoading,
      lang,
      userInfo
    } = this.props;

    const {
      orderList = [], // 订单列表
      selectedRows = [], // 选中的订单
      showGlobalPlaceOrder, // 是否显示页面中间的下单按钮
      showDeleteSearch, // 是否显示搜索内容删除图标
      searchKey, // 搜索内容
      showMapping, // 是否展示商品mapping
      bindAliCardShow, // 是否展示绑ae弹窗
      isSync, // 是否正在同步shopify订单
      visibleFulfillOrdersManuallyTip,
      status, // tab status 当前在哪个tab下
      showPlaceOrder, // 是否显示下单弹窗
      showFulfilledModal, // 是否显示手动fulfilled弹窗
      showRollBack, // 是否展示回滚弹窗
      showOrderResult, // 是否展示下单结果
      mappingProduct, // 设置maping的商品
      awaitingOrderNumber, // 下单结果 等待下单的订单数量
      succeedOrderNumber, // 下单结果 下单成功的订单数量
      failedOrderNumber, // 下单结果 下单失败的订单数量
      showRefreshMask, // 是否显示刷新页面弹窗
      showReviewBanner,
      sumSync,
      // placeOrderType,
      bannerData,
      checkAeModalType,
      isNewUserAeModalShow,
      showArchive,
      showPayPalModal,
      tutorial_type,
      flagsList,
      filteringMapp,
      filteringMappStatus,
      attention,
      checkLocalAEAccountLoading,
      showPaymentOrder,
      showPaymentResult
    } = this.state;

    const extensionVersion =
      typeof window.dsersExtVersion === 'string' &&
      window.dsersExtVersion.split('.');

    const showExtSyncTn =
      extensionVersion &&
      extensionVersion.length === 3 &&
      parseInt(extensionVersion[0]) >= 2 &&
      parseInt(extensionVersion[1]) >= 8 &&
      parseInt(extensionVersion[2]) >= 4;

    // 每次 render 都使用一个新的 cache
    const cachedBannerData = [];
    var errorTopTip = [];
    const orderList2 = this.setOrderDisabled(orderList, status); // 订单是否可选 是否可下单

    console.log('💩 orderList2', orderList2); // 这行代码别删了，用于看订单状态
   
      
    if (Array.isArray(orderList2) && orderList2.length) {
      errorTopTip = handleErrorTips(cloneDeep(orderList2),status)
    }

    let defaultTimeZoneValue =
      localStorage.getItem(`timezone${this.props.userInfo.user_id}`) ||
      undefined; // 默认时区

    // 时区列表格式更新过 老数据让他不选中
    if (defaultTimeZoneValue && !defaultTimeZoneValue.includes('/')) {
      defaultTimeZoneValue = undefined;
    }

    if (syncCanceledOrderLoading) {
      loading = false;
    }

    let howToFulfillOrderLink =
      'https://help.dsers.com/fulfill-orders-manually-on-dsers-for-shopify/';
    if (this.currentLanguage === 'fr-FR') {
      howToFulfillOrderLink =
        'https://help.dsers.com/fulfill-orders-manually-on-dsers-for-shopify/';
    }

    const tabStatusArr = [1, 2, 3, 4, 7];
    const tabStatusArr2 = [2, 7];

    // table list item
    const columns = [
      {
        key: 'orderTable',
        render: (_, record, renderIndex) => {
          // if (status === 7) {
          //   console.log('record', record);
          // }

          const activeBannerItems = {};
          // length 相等说明已经 check 完成
          if (
            record.childrens &&
            [2, 7].includes(status) &&
            cachedBannerData.length !== Object.keys(bannerData).length
          ) {
            record.childrens.forEach(i => {
              if (
                bannerData[i.shopifyProductId] &&
                bannerData[i.shopifyProductId].store_id === i.storeId &&
                i.supplierMapType &&
                !cachedBannerData.includes(i.shopifyProductId)
              ) {
                activeBannerItems[i.id] = bannerData[i.shopifyProductId];
                cachedBannerData.push(i.shopifyProductId);
              }
            });
          }
          let key = '';
          if (status == 7) {
            key = `${record.id}-${status}`;
          } else {
            key = record.id;
          }
          return (
            <OrderOne
              {...this.props}
              loading={loading}
              record={record} // 一条订单
              errTip={errorTopTip?.[record.id]}
              key={key}
              flagsList={this.state.flagsList}
              selectedRowsId={this.state.selectedRowsId}
              originalOrderDataFromRedux={orderData}
              status={status} // tab status pending还是awaiting order
              updataExt={this.updataExt} // 更新ext方法
              toggleBind={this.toggleBind}
              cancelOrder={this.cancelOrder} // 取消保存
              saveOrder={this.onlySaveOrder} // 保存订单
              placeOrder={this.placeOrder} // 下单
              markAsFulfilled={this.markAsFulfilled} // 手动fulfilled
              showMapping={this.showMapping} // 展示mapping
              renderIndex={renderIndex} // 索引
              originListMap={this.originListMap} // 没编辑之前的数据
              removedVariants={this.removedVariants} // 删除的variants
              fulfilledBy={this.fulfilledBy} // 被谁fulfilled的
              sourceBy={this.sourceBy} // 来源 ae还是othr
              callLogServiceForBlankOrder={this.callLogServiceForBlankOrder}
              activeBannerItems={activeBannerItems}
              onBannerClick={this.handleBannerClick}
              refreshFulfill={this.getOrderList}
              onChangeChecked={this.onChangeChecked}
              onePayment={this.onePayment}
              changetab={this.state.changetab}
              />
          );
        }
      }
    ];

    let DrawerOptions = [
      {
        title:intl.get('order.order_title.date'),
        key:0,
        filterComponent: this.getTimeDom()
      },
      {
        title:intl.get('order.country'),
        key:1,
        filterComponent: this.getCountryDom()
      },
      {
        title:intl.get('order.time_zone_placeholder'),
        key:2,
        filterComponent: this.getTimeZoneDom()
      },
      {
        title:intl.get('order.flags.title'),
        key:3,
        filterComponent: this.getFlagsDom()
      }
    ]

    //定制化需求
    if(CUSTOMIZATION_USER.includes(userInfo.user_id)){
      //追加React Dom
      DrawerOptions.unshift({
        title:intl.get('order.order_title.type'),
        key:4,
        filterComponent: this.getOrderTypeDom()
      })
    }


    let FilterHeaderOptions = [
      {
        key:1,
        render: this.searchFilterOrder('search')
      },
      {
        key:2,
        render: this.searchFilterOrder('filter')
      },
      {
        key:3,
        render: this.searchFilterOrder('sync')
      }
    ]
    

    return (
      <>

        <div className={orderStyles.box} id="orderBox">   
          {orderList2.length > 1 ? (
            <div className={orderStyles.backTop}>
              <div className={orderStyles.up} onClick={this.backTop}>
                <img src={require('../../assets/newBing/down.png')}></img>
              </div>
              <div className={orderStyles.down} onClick={this.backBottom}>
                <img src={require('../../assets/newBing/down.png')}></img>
              </div>
            </div>
          ) : null}
          {/* <Alert
            className={orderStyles.fullfilledAlertBox}
            message="DSers will synchronize automatically from Shopify and AliExpress when you log in to DSers. The syncing will last 10 mins. DSers will also sync automatically every 12h to ensure a more stable syncing."
            type="warning"
            showIcon
          />

          <Alert
            className={orderStyles.fullfilledAlertBox}
            message='Due to new regulations, all orders to Brazil must contain the CPF number, or the orders will fail. DSers will make the CPF number appear on your packages. You can add the CPF number of your customer in the "Company" field, in Customer Details.'
            type="warning"
            showIcon
          /> */}
          <ProductPoolBanner showBtn dispatch={this.props.dispatch} />
          <SyncAliProcess
            closeSyncLoading={this.closeSyncLoading}
            openSyncLoading={this.openSyncLoading}
            ref="syncAliProcess"
          />
          <SyncAliTimeRangeSelect
            onClose={this.closeSyncTimeRange}
            onConfirm={this.syncTask}
            visible={this.state.showSyncTimeRange}
          />
          <div
            className={className(orderStyles.searchbox, {
              [orderStyles.searchboxInPT]: this.currentLanguage == 'pt-PT'
            })}
          >
            {showDeleteSearch ? (
              <Icon
                type="close-circle"
                theme="filled"
                className={orderStyles.deleteIco}
                onClick={e => {
                  e.stopPropagation();
                  this.deleteSearchKey();
                }}
                onMouseEnter={e => {
                  e.stopPropagation();
                  this.showDeleteSearch();
                }}
              />
            ) : null}

            {/* 订单顶部order no input框 */}


            <FilterHeader title="Tmall" options={FilterHeaderOptions} renderInput={this.inputDom()} />

          </div>
          <OberloErrorStatus></OberloErrorStatus>
          <SyncAEPriceInfoToShopify />

          <div className="flagsTagList">
            {this.cancelFlags.map((item, index) => {
              if (item.checked) {
                return (
                  <div key={item.id} className="flagsTagListItem">
                    <img className="icon" src={item.img}></img>
                    <p onClick={this.openDrawer}>{item.name}</p>
                    <div
                      onClick={() => {
                        this.changesFlags(item, index);
                      }}
                    >
                      <img src="https://img.dsers.com/images/order-flags-icon/close.png"></img>
                    </div>
                  </div>
                );
              }
            })}
            {this.selectTag()}
          </div>

          {showOrderResult ? (
            <div className="orderInfoTip">

              {/* 正常提示 */}
              {failedOrderNumber ||
              awaitingOrderNumber ||
              succeedOrderNumber ? (
                <div
                  className={
                    awaitingOrderNumber && !failedOrderNumber
                      ? 'awaitTipBox'
                      : awaitingOrderNumber && failedOrderNumber
                      ? 'await_failed'
                      : failedOrderNumber
                      ? 'errorTipBox'
                      : 'successTipBox'
                  }
                >
                  <div className="tipL">
                    <div className="title_des">
                    <i>
                      {!awaitingOrderNumber ? (
                        !failedOrderNumber ? (
                          <img src={succ} alt="" />
                        ) : (
                          <img src={error} alt="" />
                        )
                      ) : (
                        <Icon type="loading" />
                      )}
                    </i>
                      {!awaitingOrderNumber ? (
                        failedOrderNumber && succeedOrderNumber ?
                        <span>
                          <div>
                            {intl.get('order.order_reault_succ_length')}
                            &nbsp;
                            {succeedOrderNumber}
                          </div>
                          <div></div>
                          <div>
                            {intl.get('order.order_reault_failed_length')}
                            &nbsp;
                            {failedOrderNumber}
                          </div>
                        </span>
                         : 
                          <span>
                             {failedOrderNumber ? intl.get('order.order_reault_failed_length') : intl.get('order.order_reault_succ_length')}
                            &nbsp;
                            {failedOrderNumber ? failedOrderNumber : succeedOrderNumber}
                          </span>
                      ) : (
                        <span>
                          {awaitingOrderNumber}{' '}
                          {awaitingOrderNumber <= 1 ? intl.get('order.order_reault_is_await_length') : intl.get('order.order_reault_await_length')}
                        </span>
                      )}
                    </div>
                    {failedOrderNumber && !awaitingOrderNumber ? (
                      <div
                        className="check"
                        onClick={() => {
                          this.changeTabStatus(7);
                          this.hideOrderResult();
                        }}
                      >
                        {intl.get('order.order_reault_checkfailed1')}
                      </div>
                    ) : null}
                     {!awaitingOrderNumber && succeedOrderNumber && !failedOrderNumber ? (
                      <div
                        className="check"
                        onClick={() => {
                          this.changeTabStatus(3);
                          this.hideOrderResult();
                        }}
                      >
                        {intl.get('order.order_reault_makepayment')}
                      </div>
                    ) : null}
                  </div>
                </div>
              ) : null}
            </div>
          ) : null}


              {succeedOrderNumber && this.state.gopay ? 
                <div className={'awaitTipBox'} style={{marginTop : '16px'}}>
                  <div className='pay-title'>
                    <Icon style={{cursor:'pointer',color : '#1E88E5'}} type="info-circle" />
                    &nbsp;
                    &nbsp;
                      <div>
                        {intl.get('order.order_language.pay')}
                      </div>
                  </div>
                  <i class="material-icons" style={{color : '#1E88E5'}} onClick={this.closePay}>close</i>
              </div>: null}


          <div className="order_fixed_bar">
            <Tabs
              activeKey={`${status}`}
              tabBarGutter={0}
              onChange={this.changeTabStatus}
              className={className({ [orderStyles.tabLoaing]: loading })}
            >
              {orderStatusMapArr.map(item => {
                return (
                  <TabPane
                    tab={this.getOrderTabTitle(item)}
                    key={`${item[0]}`}
                  />
                );
              })}
            </Tabs>
          </div>
          <SyncTmallPayment 
            status={status} 
            timezoneRegion={this.props.timezoneRegion} 
            userInfo={this.props.userInfo} 
            types={this.state.types}
            handleDeatilPayment={this.handleDeatilPayment}
            />
          {/* 订单报错文案 */}
          {/* {this.returnTextTip(status)} */}
          {/* 订单报错文案下边各种筛选以及flex头部 */}
          {this.state.isFixed ? <div className="fiex_hidden"></div> : null}
          {this.state.isFixed ? <div className="fiex_backsq"></div> : null}
          <div
            className={!this.state.isFixed ? 'fiex_visitle' : 'fixed_visitle'}
          >
            <div className="tabHeaderBox">
              <div class="border_left"></div>
              <div class="border_right"></div>

              <div className="checkBoxInqq">
                <div
                  className="check"
                  style={{
                    flex: status == 2 || status == 7 || status == 3 ? 0 : 1
                  }}
                >
                  <Checkbox
                    onChange={this.handleSelectRows}
                    indeterminate={
                      selectedRows.length == 0
                        ? false
                        : selectedRows.length != orderList2.length
                    }
                    checked={selectedRows.length}
                  />
                </div>

                {/*----------------- 头部 -----------------  */}
                <div
                  className="tabHead"
                  style={{
                    width:
                      status == 2 || status == 7 || status == 6 || status == 3
                        ? '100%'
                        : null
                  }}
                >
                  {status == 6 ? (
                    <>
                      <div className="sixBoxFixed">
                        <div className="sixBoxFixedL">
                          <Button
                            className="fullNbTN orderAgan"
                            type="primary"
                            disabled={
                              checkLocalAEAccountLoading ||
                              loading ||
                              selectedRows.length === 0 ||
                              !this.getSelectedCanOrder()
                            }
                            onClick={() => {
                              this.purchaseMultiple();
                            }}
                          >
                            <i class="material-icons notranslate">sync</i>
                            {intl.get('order.place_order.tm_btn', { key: 4 })}
                          </Button>
                        </div>
                        <div className="sixBoxFixedR">
                          <Button
                            className="fullNbTN twosw"
                            onClick={this.markMultipleFulfilled}
                            disabled={selectedRows.length === 0}
                          >
                            <i
                              class="material-icons notranslate"
                              style={{
                                color:
                                  selectedRows.length === 0
                                    ? 'rgba(0, 0, 0, 0.25)'
                                    : 'rgba(0, 0, 0, 0.5)'
                              }}
                            >
                              assignment
                            </i>
                            {intl.get('order.more_action.action_menu')}
                          </Button>
                          <span className="bkxwq"></span>
                          <span className="bkxwq"></span>

                          <Select
                            allowClear
                            placeholder={intl.get(
                              'order.canceled_by.placeholder'
                            )}
                            className={orderStyles.fromSelect}
                            style={{ minWidth: 125 }}
                            onChange={this.changeStatusCanceled}
                            value={
                              this.cancelBy === 0 ? undefined : this.cancelBy
                            }
                            getPopupContainer={triggerNode =>
                              triggerNode.parentNode
                            }
                            suffixIcon={
                              <img
                                src={require('../../assets/newImportList/icon_expand_more-24px.png')}
                              ></img>
                            }
                          >
                            <Option value={1}>
                              {intl.get('order.canceled_by.shopify')}
                            </Option>
                            <Option value={5}>
                              {intl.get('order.canceled_by.tm')}
                            </Option>
                          </Select>

                          <b
                            className={orderStyles.sortBtn}
                            onClick={this.changeSort}
                          >
                            <Icon
                              type="caret-up"
                              className={
                                this.sortBy == 1
                                  ? orderStyles.sortBtnActive
                                  : ''
                              }
                            />
                            <Icon
                              type="caret-down"
                              className={
                                this.sortBy == 0
                                  ? orderStyles.sortBtnActive
                                  : ''
                              }
                            />
                          </b>
                          <span className="bkxwq"></span>
                          <Button
                            className={orderStyles.clearFilter}
                            onClick={this.clearFilter}
                          >
                            <Icon type="sync" />
                          </Button>
                        </div>
                      </div>
                      {/* 为6状态的时候底部 */}
                    </>
                  ) : (
                    <>
                      {tabStatusArr2.includes(status) ? (
                        (selectedRows.length === 0 ||
                          !this.getSelectedCanOrder()) &&
                        status == 2 ? (
                          <Tooltip
                            title=""
                            getPopupContainer={triggerNode =>
                              triggerNode.parentNode || document.body
                            }
                          >
                            <Button
                              className="disbtn_s"
                              type="primary"
                              disabled
                            >
                              <i class="material-icons notranslate">input</i>
                              {intl.get('order.place_order.tm_btn', { key: 1 })}
                            </Button>
                          </Tooltip>
                        ) : (
                          <div className="kqwe">
                            <Button
                              type="primary"
                              disabled={
                                checkLocalAEAccountLoading ||
                                loading ||
                                (selectedRows.length === 0 &&
                                  !this.getSelectedCanOrder())
                              }
                              onClick={this.purchaseMultiple}
                            >
                              <i
                                class="material-icons notranslate"
                                style={{
                                  color: selectedRows.length
                                    ? '#fff'
                                    : 'rgba(0,0,0,.25)'
                                }}
                              >
                                input
                              </i>
                              {intl.get('order.place_order.tm_btn', { key: 1 })}
                            </Button>
                          </div>
                        )
                      ) : null}
                      <Tooltip
                        title={
                          <span>{intl.get('order.orderPayment.buttonTip')}</span>
                          }
                          >
                        <a
                          className={className(orderStyles.goAliPayBtn, {
                            [orderStyles.hideGoAliPayBtn]: status != 3
                          })}
                          onClick={this.handleOpenPayment}
                          disabled={selectedRows.length == 0 ? true : false}
                        >
                          <img
                            style={{
                              width: 24,
                              marginRight: 10,
                              marginTop: '-3px'
                            }}
                            src={selectedRows.length == 0 ? 
                              require('../../assets/newBing/pay-icon.svg')
                              :
                              require('../../assets/newBing/pay-icon-disabled.svg') 
                            }
                          ></img>
                          {intl.get('order.make_payment.btn')}
                        </a>
                      </Tooltip>

                      <div className="dsds" style={{ display: 'flex' }}>
                        {tabStatusArr.includes(status) ? (
                          <span
                            className={status == 1 ? 'fullBtn iuwq' : 'fullBtn'}
                          >
                            <Button
                              onClick={this.markMultipleFulfilled}
                              disabled={!this.state.selectedRows.length}
                              data-labele="pending1"
                            >
                              <i
                                style={
                                  this.state.selectedRows.length
                                    ? { color: 'rgba(0,0,0,.5)' }
                                    : { color: 'rgba(0,0,0,.25)' }
                                }
                                class="material-icons"
                              >
                                assignment
                              </i>
                              <span
                                style={
                                  this.state.selectedRows.length
                                    ? { color: 'rgba(0,0,0,.5)' }
                                    : { color: 'rgba(0,0,0,.25)' }
                                }
                              >
                                {intl.get('order.more_action.action_menu')}
                              </span>
                            </Button>
                          </span>
                        ) : null}

                        <div className="fullRight">
                          {/* fulfilled 状态控制 */}
                          {status == 5 ? (
                            <>
                            <Button
                                onClick={this.showRollBackOrders}
                                disabled={selectedRows.length === 0}
                                className="fullNbTN"
                              >
                                <i class="material-icons notranslate">undo</i>{' '}
                                {intl.get('order.roll_back_btn')}
                              </Button>
                              <span className="bkxwq"></span>
                              <Button
                                className="fullNbTN"
                                onClick={() => {
                                  this.setState({
                                    showArchive: true
                                  });
                                }}
                                disabled={selectedRows.length === 0}
                              >
                                <i class="material-icons notranslate">
                                  archive
                                </i>{' '}
                                {/* {intl.get('order.archive')} */}
                                Archive
                              </Button>
                              <span className="bkxwq"></span>
                              <Select
                                allowClear
                                placeholder="Method"
                                className={orderStyles.fromSelect}
                                style={{ width: 100 }}
                                dropdownMatchSelectWidth={false}
                                onChange={this.changeStatusFulfilled}
                                suffixIcon={
                                  <img
                                    src={require('../../assets/newImportList/icon_expand_more-24px.png')}
                                  ></img>
                                }
                                value={
                                  this.fulfilledBy === 0
                                    ? undefined
                                    : this.fulfilledBy
                                }
                                getPopupContainer={triggerNode =>
                                  triggerNode.parentNode
                                }
                              >
                                <Option value={2}>
                                  {intl.get('order.ful_with_tracking')}
                                </Option>
                                <Option value={1}>
                                  {intl.get('order.ful_by_shopify')}
                                </Option>
                                <Option value={3}>
                                  {intl.get('order.ful_manually')}
                                </Option>
                                  </Select>
                                </>
                          ) : null}
                          {status == 9 ? null : <span className="bkxwq"></span>}
                          <span className="bkxwq"></span>
                          {status != 7 ? (
                            <b
                              className={orderStyles.sortBtn}
                              onClick={this.changeSort}
                            >
                              <Icon
                                type="caret-up"
                                className={
                                  this.sortBy == 1
                                    ? orderStyles.sortBtnActive
                                    : ''
                                }
                              />
                              <Icon
                                type="caret-down"
                                className={
                                  this.sortBy == 0
                                    ? orderStyles.sortBtnActive
                                    : ''
                                }
                              />
                            </b>
                          ) : null}
                          {status == 6 ? (
                            <Select
                              allowClear
                              placeholder={intl.get(
                                'order.canceled_by.placeholder'
                              )}
                              className={orderStyles.fromSelect}
                              style={{ width: 108 }}
                              onChange={this.changeStatusCanceled}
                              value={
                                this.cancelBy === 0 ? undefined : this.cancelBy
                              }
                              getPopupContainer={triggerNode =>
                                triggerNode.parentNode
                              }
                            >
                              <Option value={1}>
                                {intl.get('order.canceled_by.shopify')}
                              </Option>
                              <Option value={2}>
                                {intl.get('order.canceled_by.ae')}
                              </Option>
                            </Select>
                          ) : null}

                          <span className="bkxwq"></span>
                          <Button
                            className={orderStyles.clearFilter}
                            onClick={this.clearFilter}
                          >
                            <Icon type="sync" />
                          </Button>
                          {/* {status == 3 ? <span className="bkxwq"></span> : null} */}

                          {/* fullRight右侧 */}
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/*----------------- 底部 -----------------  */}

          <StandardTable
            selectedRows={selectedRows}
            loading={loading || checkLocalAEAccountLoading}
            data={{
              list: orderList2
            }}
            pagination={false}
            orderType="tmall"
            rowKey="id"
            columns={columns}
            onSelectRow={this.handleSelectRows}
            onChange={this.changePager}
            showInfo={false}
            localeEmptyText
            orderStatus={this.status}
            isSync={isSync}
            goSetting={this.goSetting}
            storeData={this.storeData}
            orderStatusNum={this.countObj}
          />
          {/* {this.renderTip()} */}
          <OnlyPagination
            len={this.listLength}
            pageSize={this.pageSize}
            currentPage={this.currentPage}
            changePageSize={this.changePageSize}
            changePager={this.changePager}
            count={this.count}
          />
        </div>

        {/* 下单窗口 */}
        {showPlaceOrder ? (
          <OrderConfirm
            visible={showPlaceOrder}
            supplyPlatform={4}
            data={this.placeOrderData}
            status={status}
            goFailOrder={() => {
              this.changeTabStatus(7);
              this.setState({
                showPlaceOrder:false
              })
            }}
            getExtensionPlaceProcess={this.getExtensionPlaceProcess}
            hidePlaceOrder={this.hidePlaceOrder}
            onClose={this.handleOrderConfirmClose}
            originalOldOrderMap={this.originalOldOrderMap}
          />
        ) : null}
          {showPaymentOrder ? (
          <PaymentOrder
            visible={showPaymentOrder}
            supplyPlatform={4}
            data={this.paymentOrderData}
            status={status}
            hidePaymentOrder={this.hidePaymentOrder}
            onClose={this.handleOrderConfirmClose}
            nowType={this.nowType}
          />
        ) : null}
        {!localStorage.getItem('noPayPalReminder') ? (
          <Modal
            visible={showPayPalModal}
            width={560}
            footer={
              <div className={styles.btnFooter}>
                <Button
                  type="primary"
                  data="dx"
                  onClick={() => {
                    window.location.href = '/app/settings?id=8';
                    localStorage.setItem('lastShow', Date.now());
                  }}
                  className={styles.goBtn}
                >
                  {intl.get('paypal.paypal_change')}
                </Button>
                <Button
                  data="bk"
                  onClick={this.closePayPalModal}
                  className={styles.stayBtn}
                >
                  {intl.get('paypal.disimiss')}
                </Button>
              </div>
            }
            className={styles.window}
            closable={false}
            title={intl.get('paypal.paypal_authorization_title')}
          >
            <div className={styles.alertWindow}>
              <p className={styles.dec}>
                {intl.getHTML('paypal.paypal_authorization_content')}
              </p>
              <div className={styles.reminder}>
                <Checkbox
                  className={styles.checkbox}
                  id="alertCheckbox"
                  onChange={e => {
                    this.setConfirmChecked(e);
                  }}
                >
                  {intl.get('bargain.m_reminder')}
                </Checkbox>
              </div>
            </div>
          </Modal>
        ) : null}

        {this.state.guideModal && (
          <GuideModal
            status={true}
            guideStorage="order"
            closeModal={this.closeModal}
          />
        )}

        {showFulfilledModal ? (
          <OrderFulfilled
            data={this.fulfilledList}
            status={status}
            hideFulfilledModal={this.hideFulfilledModal}
            fulfilledChildId={this.fulfilledChildId}
            originalOldOrderMap={this.originalOldOrderMap}
          />
        ) : null}

        {showRollBack ? (
          <OrderRollBack
            data={selectedRows}
            hideRollBackOrders={this.hideRollBackOrders}
            status={status}
            originalOldOrderMap={this.originalOldOrderMap}
          />
        ) : null}

        {showArchive ? (
          <OrderArchive
            data={selectedRows}
            hideArchiveOrders={this.hideArchiveOrders}
            status={status}
            originalOldOrderMap={this.originalOldOrderMap}
          />
        ) : null}

        <Mapping
          visible={showMapping}
          originProductData={mappingProduct}
          hideSupplier={this.hideDeputySupplier}
          fbdSupply={this.fbdSupply}
        />

        {/* 刷新遮罩 */}
        <RefreshMask visible={showRefreshMask} />

        <NewUserWithoutAeModal
          visible={isNewUserAeModalShow}
          closeModal={this.closeNewUserAeModal}
        />
        {/* 插件下单进度 以后可能会移除 */}
        <ExtensionPlaceOrderProcess ref="extensionProcess" />
        {/* 检测是否有意外中断的插件下单任务
        <CheckInterreptedExtTask /> */}

        {/* 新版过滤项 */}
        <FilterDrawer
          defaultActiveKey={[0,1,2,3,4]}
          destroyOnClose={true}
          onClose={() => {
            this.setState({
              drawerVisiable:false
            })
          }}
          visible={this.state.drawerVisiable}
          title={intl.get('order.order_title.title')}
          options={DrawerOptions}
          onConfirm={()=>{
            this.setState({
              confirmSelect:true,
              tagVisiable:true
            })
            this.onFilterConfirm('flags')
          }}
          onCancel={() => {
            this.onClearFilterComfig()
          }}
        />
      
      </>
    );
  }
}
